<template>
  <nav>
    <div class="nav-inner-container">
      <div class="logo">
        <router-link to="/"><img src="@/assets/logo1.svg" alt="瑞和云图" class="nav-logo"></router-link>
      </div>
      
      <!-- 移动端汉堡菜单按钮 -->
      <div class="mobile-menu-btn" :class="{ 'is-active': isMobileMenuOpen }" @click="toggleMobileMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <!-- 移动端遮罩层 -->
      <div class="mobile-overlay" :class="{ 'is-visible': isMobileMenuOpen }" @click="closeMobileMenu"></div>
      
      <!-- 移动端侧边菜单 -->
      <div class="mobile-menu" :class="{ 'is-open': isMobileMenuOpen }">
        <div class="mobile-menu-header">
        <div class="mobile-logo">
          <router-link to="/" @click="closeMobileMenu"><img src="@/assets/logo1.svg" alt="瑞和云图" class="mobile-nav-logo"></router-link>
        </div>
          <div class="mobile-close-btn" @click="closeMobileMenu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
        </div>
        
        <div class="mobile-menu-content">
          <div class="mobile-nav-item">
            <router-link to="/" class="mobile-nav-link" active-class="" exact-active-class="" :class="{ active: isHomeRoute }" @click="onHomeNav">
              <span>首页</span>
            </router-link>
          </div>
          <!-- 产品 - 手风琴 -->
          <div class="mobile-nav-item accordion" :class="{ 'is-expanded': mobileAccordion === 'product' }">
            <div class="mobile-nav-link" @click="toggleMobileAccordion('product')">
              <span>产品</span>
              <svg class="accordion-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
            <div class="accordion-content">
              <!-- 产品分类tabs -->
              <div class="mobile-product-tabs">
              <!--
                <div class="mobile-tab" :class="{ active: mobileProductTab === 'hot' }" @click.stop="mobileProductTab = 'hot'">热门</div>
                -->
                <div class="mobile-tab" :class="{ active: mobileProductTab === 'cloud_computing' }" @click.stop="mobileProductTab = 'cloud_computing'">AI智算</div>
                <div class="mobile-tab" :class="{ active: mobileProductTab === 'cloud_security' }" @click.stop="mobileProductTab = 'cloud_security'">云安全</div>
                <div class="mobile-tab" :class="{ active: mobileProductTab === 'edge_cloud' }" @click.stop="mobileProductTab = 'edge_cloud'">云基础设施</div>
                <div class="mobile-tab" :class="{ active: mobileProductTab === 'compute_network' }" @click.stop="mobileProductTab = 'compute_network'">算力网络</div>
                <div class="mobile-tab" :class="{ active: mobileProductTab === 'security' }" @click.stop="mobileProductTab = 'security'">安全</div>
                <div v-if="showStorageProducts" class="mobile-tab" :class="{ active: mobileProductTab === 'storage' }" @click.stop="goToStorageLanding">存储</div>
              </div>
              <div class="mobile-product-list">
                <template v-if="mobileProductTab === 'hot'">
                  <router-link 
                    v-for="product in hotProducts" 
                    :key="product.id" 
                    :to="product.path" 
                    class="mobile-product-item"
                    @click="closeMobileMenu"
                  >
                    <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                    <div class="mobile-product-info">
                      <span class="mobile-product-name">{{ product.name }}</span>
                      <span v-if="product.description" class="mobile-product-desc">{{ product.description }}</span>
                    </div>
                  </router-link>
                </template>
                <template v-else-if="mobileProductTab === 'cloud_security'">
                  <router-link 
                    v-for="product in cloudSecurityProducts" 
                    :key="product.id" 
                    :to="product.path" 
                    class="mobile-product-item"
                    @click="closeMobileMenu"
                  >
                    <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                    <div class="mobile-product-info">
                      <span class="mobile-product-name">{{ product.name }}</span>
                      <span v-if="product.description" class="mobile-product-desc">{{ product.description }}</span>
                    </div>
                  </router-link>
                </template>
                <template v-else-if="mobileProductTab === 'edge_cloud'">
                  <router-link 
                    v-for="product in edgeCloudProducts" 
                    :key="product.id" 
                    :to="product.path" 
                    class="mobile-product-item"
                    @click="closeMobileMenu"
                  >
                    <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                    <div class="mobile-product-info">
                      <span class="mobile-product-name">{{ product.name }}</span>
                      <span v-if="product.description" class="mobile-product-desc">{{ product.description }}</span>
                    </div>
                  </router-link>
                </template>
                <template v-else-if="mobileProductTab === 'compute_network'">
                  <router-link 
                    v-for="product in computeNetworkProducts" 
                    :key="product.id" 
                    :to="product.path" 
                    class="mobile-product-item"
                    @click="closeMobileMenu"
                  >
                    <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                    <div class="mobile-product-info">
                      <span class="mobile-product-name">{{ product.name }}</span>
                      <span v-if="product.description" class="mobile-product-desc">{{ product.description }}</span>
                    </div>
                  </router-link>
                </template>
                <template v-else-if="mobileProductTab === 'cloud_computing'">
                  <router-link 
                    v-for="product in cloudComputingProducts" 
                    :key="product.id" 
                    :to="product.path" 
                    class="mobile-product-item"
                    @click="closeMobileMenu"
                  >
                    <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                    <div class="mobile-product-info">
                      <span class="mobile-product-name">{{ product.name }}</span>
                      <span v-if="product.description" class="mobile-product-desc">{{ product.description }}</span>
                    </div>
                  </router-link>
                </template>
                <template v-else-if="mobileProductTab === 'security'">
                  <router-link 
                    v-for="product in securityProducts" 
                    :key="product.id" 
                    :to="product.path" 
                    class="mobile-product-item"
                    @click="closeMobileMenu"
                  >
                    <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                    <div class="mobile-product-info">
                      <span class="mobile-product-name">{{ product.name }}</span>
                      <span v-if="product.description" class="mobile-product-desc">{{ product.description }}</span>
                    </div>
                  </router-link>
                </template>
                <template v-else-if="mobileProductTab === 'storage'">
                  <a
                    href="#"
                    class="mobile-storage-smartx-cta mobile-storage-smartx-cta--under-title"
                    @click.prevent="goToStorageOverviewFromBanner"
                  >
                    <span class="mobile-storage-smartx-cta__main">存储</span>
                    <span class="mobile-storage-smartx-cta__hint">芯存 XNAS 与机架式存储产品线</span>
                    <span class="mobile-storage-smartx-cta__arrow" aria-hidden="true">→</span>
                  </a>
                  <div
                    v-for="row in nasStorageRows"
                    :key="row.label"
                    class="mobile-storage-section"
                  >
                    <div class="mobile-storage-smartx-row">
                      <span class="mobile-storage-label-col">{{ row.label }}</span>
                      <div class="mobile-storage-smartx-body">
                        <div v-if="row.groupTitle" class="mobile-storage-group-banner">
                          <span class="mobile-storage-group-title">{{ row.groupTitle }}</span>
                          <span v-if="row.groupTagline" class="mobile-storage-group-desc">{{ row.groupTagline }}</span>
                        </div>
                        <router-link
                          v-for="item in row.items"
                          :key="item.slug"
                          :to="item.path"
                          class="mobile-product-item mobile-product-item--nested"
                          @click="closeMobileMenu"
                        >
                          <div class="mobile-product-info">
                            <span class="mobile-product-name mobile-storage-product-name">{{ item.name }}</span>
                            <span v-if="item.description" class="mobile-product-desc">{{ item.description }}</span>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="mobile-nav-item">
            <router-link to="/compute-tower" class="mobile-nav-link" @click="closeMobileMenu">
              <span>应用场景</span>
            </router-link>
          </div>
          
          <!-- 解决方案 - 手风琴 -->
          <div class="mobile-nav-item accordion" :class="{ 'is-expanded': mobileAccordion === 'solution' }">
            <div class="mobile-nav-link" @click="toggleMobileAccordion('solution')">
              <span>解决方案</span>
              <svg class="accordion-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
            <div class="accordion-content">
              <div class="mobile-product-tabs mobile-solution-tabs">
                <div
                  v-for="tab in solutionNavTabs"
                  :key="tab.id"
                  class="mobile-tab"
                  :class="{ active: mobileSolutionTab === tab.id }"
                  @click.stop="mobileSolutionTab = tab.id"
                >{{ tab.title.replace('专题', '') }}</div>
              </div>
              <router-link
                v-for="item in currentMobileSolutionItems"
                :key="item.path"
                :to="item.path"
                class="accordion-link"
                @click="closeMobileMenu"
              >{{ item.name }}</router-link>
            </div>
          </div>
          
          <!-- 服务与支持 - 手风琴（移动端隐藏） -->
          <div class="mobile-nav-item mobile-nav-item--hidden accordion" :class="{ 'is-expanded': mobileAccordion === 'service' }">
            <div class="mobile-nav-link" @click="toggleMobileAccordion('service')">
              <span>服务与支持</span>
              <svg class="accordion-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
            <div class="accordion-content">
              <router-link to="/services/security-tech" class="accordion-link" @click="closeMobileMenu">安全技术服务</router-link>
              <router-link to="/services/security-consulting" class="accordion-link" @click="closeMobileMenu">安全咨询服务</router-link>
              <router-link to="/services/security-training" class="accordion-link" @click="closeMobileMenu">安全培训服务</router-link>
            </div>
          </div>
          
          <!-- 成功案例 - 直接链接 -->
          <div class="mobile-nav-item">
            <router-link to="/#success-cases" class="mobile-nav-link" @click="onSuccessCasesNav">
              <span>成功案例</span>
            </router-link>
          </div>

          <!-- 了解瑞和云图 - 直接链接 -->
          <div class="mobile-nav-item">
            <router-link to="/about-us" class="mobile-nav-link" @click="closeMobileMenu">
              <span>了解瑞和云图</span>
            </router-link>
          </div>
        </div>
      </div>
      
      <!-- PC端导航链接 -->
      <ul class="nav-links">
        <li
          :class="{ active: isHomeRoute }"
          @mouseenter="scheduleDirectNav('/')"
          @mouseleave="clearDirectNavTimer"
        >
          <router-link to="/" active-class="" exact-active-class="" :class="{ active: isHomeRoute }" @click="onHomeNav">首页</router-link>
        </li>
        <li class="has-dropdown" 
            @mouseenter="showProductDropdown" 
            @mouseleave="handleProductMouseLeave"
            :class="{ 'active': isProductRoute }">
          <a href="#" @click.prevent="onProductMenuClick">产品</a>
          <div
            class="dropdown-menu product-dropdown"
            :class="{ 'product-dropdown--no-params': !isSearching && activeProductTab === 'security' }"
            v-show="isProductDropdownOpen"
            @mouseenter="showProductDropdown"
            @mouseleave="handleProductMouseLeave"
          >
            <div
              class="dropdown-inner-container"
              :style="{ '--product-dropdown-height': `${productDropdownHeight}px` }"
            >
              <div class="dropdown-tabs">
                  <div class="tab-header" :class="{ active: activeProductTab === 'cloud_computing' }" @click="setActiveProductTab('cloud_computing')" @mouseenter="setActiveProductTab('cloud_computing')">
                    <svg class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                      <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                      <path d="M2 17l10 5 10-5"/>
                      <path d="M2 12l10 5 10-5"/>
                    </svg>
                    <span>AI智算</span>
                  </div>
                  <div class="tab-header" :class="{ active: activeProductTab === 'cloud_security' }" @click="setActiveProductTab('cloud_security')" @mouseenter="setActiveProductTab('cloud_security')">
                    <svg class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                      <path d="M19 11H5a4 4 0 0 0-4 4v0a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v0a4 4 0 0 0-4-4z"/>
                      <path d="M12 11V7"/>
                      <circle cx="12" cy="5" r="2"/>
                    </svg>
                    <span>云安全</span>
                  </div>
                  <div class="tab-header" :class="{ active: activeProductTab === 'edge_cloud' }" @click="setActiveProductTab('edge_cloud')" @mouseenter="setActiveProductTab('edge_cloud')">
                    <svg class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                      <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z"/>
                    </svg>
                    <span>云基础设施</span>
                  </div>
                  <div class="tab-header" :class="{ active: activeProductTab === 'compute_network' }" @click="setActiveProductTab('compute_network')" @mouseenter="setActiveProductTab('compute_network')">
                    <svg class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                      <circle cx="12" cy="12" r="3"/>
                      <path d="M12 2v4M12 18v4M2 12h4M18 12h4"/>
                      <path d="M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                    </svg>
                    <span>算力网络</span>
                  </div>
                  <div class="tab-header" :class="{ active: activeProductTab === 'security' }" @click="setActiveProductTab('security')" @mouseenter="setActiveProductTab('security')">
                    <svg class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                      <path d="M9 12l2 2 4-4"/>
                    </svg>
                    <span>安全产品</span>
                  </div>
                  <div v-if="showStorageProducts" class="tab-header" :class="{ active: activeProductTab === 'storage' }" @click="setActiveProductTab('storage')" @mouseenter="setActiveProductTab('storage')">
                    <svg class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                      <ellipse cx="12" cy="5" rx="9" ry="3"/>
                      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
                      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
                    </svg>
                    <span>存储</span>
                  </div>
                </div>
                <div
                  class="dropdown-middle"
                  :class="{
                    'non-security-layout': !isSearching && activeProductTab !== 'security' && activeProductTab !== 'storage',
                    'security-grid-layout': !isSearching && activeProductTab === 'security',
                    'storage-layout': !isSearching && activeProductTab === 'storage'
                  }"
                >
              <div
                class="dropdown-products-area"
                :class="{ 'is-searching': isSearching }"
                :style="{ '--product-mask-height': `${productMaskHeight}px` }"
              >
              <div class="dropdown-content">
                <!-- 搜索结果模式：显示所有匹配产品 -->
                <template v-if="isSearching">
                  <div class="tab-content active">
                    <div class="section-title">
                      搜索结果
                      <span class="result-count">（共 {{ allFilteredProducts.length }} 个产品）</span>
                    </div>
                    <div class="product-items-container">
                      <template v-if="allFilteredProducts.length > 0">
                        <div 
                          v-for="product in allFilteredProducts" 
                          :key="product.id" 
                          class="product-item" 
                          :class="{ 'product-item-selected': selectedProduct && selectedProduct.id === product.id }"
                          @mouseenter="selectProduct(product)"
                          @mousedown.prevent="navigateToProduct(product.path)"
                        >
                          <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                          <h4 v-html="highlightText(product.name)"></h4>
                          <p v-if="product.description" v-html="highlightText(product.description)"></p>
                          <span class="product-category-tag">{{ product.category }}</span>
                        </div>
                      </template>
                      <div v-else class="no-results">
                        <span>未找到匹配的产品，请尝试其他关键词</span>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 正常标签页模式 -->
                <template v-else>
                  <!-- Content for Hot Products -->
                  <div class="tab-content" :class="{ active: activeProductTab === 'hot' }">
                    <div class="section-title">热门产品</div>
                    <div class="product-items-container security-list">
                      <div 
                        v-for="product in hotProducts" 
                        :key="product.id" 
                        class="product-item" 
                        :class="{ 'product-item-selected': selectedProduct && selectedProduct.id === product.id }"
                        @mouseenter="selectProduct(product)"
                        @click="selectProduct(product)"
                      >
                        <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                        <h4>{{ product.name }}</h4>
                        <p v-if="product.description">{{ product.description }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- Content for Cloud Security -->
                  <div class="tab-content" :class="{ active: activeProductTab === 'cloud_security' }">
                    <h3 class="section-title">云安全</h3>
                    <div class="product-items-container">
                      <div 
                        v-for="product in cloudSecurityProducts" 
                        :key="product.id" 
                        class="product-item" 
                        :class="{ 'product-item-selected': selectedProduct && selectedProduct.id === product.id }"
                        @mouseenter="selectProduct(product)"
                        @mousedown.prevent="navigateToProduct(product.path)"
                      >
                        <div class="product-item-content">
                          <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                          <h4>{{ product.name }}</h4>
                          <p v-if="product.description">{{ product.description }}</p>
                        </div>
                        <div class="product-item-arrow">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-content" :class="{ active: activeProductTab === 'edge_cloud' }">
                    <h3 class="section-title">云基础设施</h3>
                    <div class="product-items-container">
                      <div 
                        v-for="product in edgeCloudProducts" 
                        :key="product.id" 
                        class="product-item" 
                        :class="{ 'product-item-selected': selectedProduct && selectedProduct.id === product.id }"
                        @mouseenter="selectProduct(product)"
                        @mousedown.prevent="navigateToProduct(product.path)"
                      >
                        <div class="product-item-content">
                          <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                          <h4>{{ product.name }}</h4>
                          <p v-if="product.description">{{ product.description }}</p>
                        </div>
                        <div class="product-item-arrow">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-content" :class="{ active: activeProductTab === 'compute_network' }">
                    <h3 class="section-title">算力网络</h3>
                    <div class="product-items-container">
                      <div 
                        v-for="product in computeNetworkProducts" 
                        :key="product.id" 
                        class="product-item" 
                        :class="{ 'product-item-selected': selectedProduct && selectedProduct.id === product.id }"
                        @mouseenter="selectProduct(product)"
                        @mousedown.prevent="navigateToProduct(product.path)"
                      >
                        <div class="product-item-content">
                          <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                          <h4>{{ product.name }}</h4>
                          <p v-if="product.description">{{ product.description }}</p>
                        </div>
                        <div class="product-item-arrow">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Content for Cloud Computing (AI智算) -->
                  <div class="tab-content" :class="{ active: activeProductTab === 'cloud_computing' }">
                    <h3 class="section-title">AI智算</h3>
                    <div class="product-items-container">
                      <div 
                        v-for="product in cloudComputingProducts" 
                        :key="product.id" 
                        class="product-item" 
                        :class="{ 'product-item-selected': selectedProduct && selectedProduct.id === product.id }"
                        @mouseenter="selectProduct(product)"
                        @mousedown.prevent="navigateToProduct(product.path)"
                      >
                        <div class="product-item-content">
                          <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                          <h4>{{ product.name }}</h4>
                          <p v-if="product.description">{{ product.description }}</p>
                        </div>
                        <div class="product-item-arrow">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Content for Security Products -->
                  <div class="tab-content" :class="{ active: activeProductTab === 'security' }">
                    <h3 class="section-title">安全产品</h3>
                    <div class="product-items-container">
                      <div 
                        v-for="product in securityProducts" 
                        :key="product.id" 
                        class="product-item" 
                        :class="{ 'product-item-selected': selectedProduct && selectedProduct.id === product.id }"
                        @mouseenter="selectProduct(product)"
                        @mousedown.prevent="navigateToProduct(product.path)"
                      >
                        <div class="product-item-content">
                          <img v-if="shouldShowProductIcon(product)" :src="product.icon" :alt="product.name">
                          <h4>{{ product.name }}</h4>
                          <p v-if="product.description">{{ product.description }}</p>
                        </div>
                        <div class="product-item-arrow">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showStorageProducts" class="tab-content tab-content--storage" :class="{ active: activeProductTab === 'storage' }">
                    <h3 class="section-title">存储</h3>
                    <!-- 对齐 SmartX 超融合：大标题下、软件/一体机分栏上 -->
                    <a
                      href="#"
                      class="storage-dd-smartx-cta storage-dd-smartx-cta--under-title"
                      @mousedown.prevent="navigateToProduct('/product/storage')"
                    >
                      <span class="storage-dd-smartx-cta__main">存储</span>
                      <span class="storage-dd-smartx-cta__hint">芯存 XNAS 与机架式存储产品线</span>
                      <span class="storage-dd-smartx-cta__arrow" aria-hidden="true">→</span>
                    </a>
                    <div class="storage-dropdown-rows">
                      <div
                        v-for="row in nasStorageRows"
                        :key="row.label"
                        class="storage-dd-row"
                      >
                        <div class="storage-dd-label-col">
                          <span class="storage-dd-label">{{ row.label }}</span>
                        </div>
                        <div class="storage-dd-body">
                          <div v-if="row.groupTitle" class="storage-dd-group">
                            <div class="storage-dd-group-title">{{ row.groupTitle }}</div>
                            <p v-if="row.groupTagline" class="storage-dd-group-desc">
                              {{ row.groupTagline }}
                            </p>
                          </div>
                          <div
                            v-for="item in row.items"
                            :key="item.slug"
                            class="storage-dd-item-wrap"
                          >
                            <div class="storage-dd-item-main">
                              <div
                                class="product-item product-item--storage"
                                :class="{
                                  'product-item--storage-lead': !row.groupTitle,
                                  'product-item--storage-model': !!row.groupTitle,
                                  'product-item-selected':
                                    selectedProduct &&
                                    selectedProduct.path === item.path
                                }"
                                @mouseenter="selectStorageNavItem(item.path)"
                                @mousedown.prevent="navigateToProduct(item.path)"
                              >
                                <h4>{{ item.name }}</h4>
                                <p v-if="item.description">{{ item.description }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
                </div>
                <!-- 产品说明：放在产品列表下方，随鼠标悬停产品实时切换 -->
                <div v-if="false" class="product-inline-panel">
                  <div class="params-panel">
                    <div class="params-panel-header">
                      <div class="params-panel-title">{{ selectedProductName }}</div>
                      <div v-if="selectedProductDescription" class="params-panel-subtitle">
                        {{ selectedProductDescription }}
                      </div>
                      <a
                        v-if="selectedProductPath && activeProductTab !== 'security'"
                        href="#"
                        class="params-more-link"
                        @click.prevent="navigateToProduct(selectedProductPath)"
                      >了解更多 >></a>
                    </div>

                    <div class="params-panel-body">
                      <div v-for="(spec, idx) in selectedProductSpecRows" :key="idx" class="feature-card">
                        <div class="feature-card-icon">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                            <polyline points="22 4 12 14.01 9 11.01"/>
                          </svg>
                        </div>
                        <div class="feature-card-content">
                          <div class="feature-card-title">{{ spec.title }}</div>
                          <div class="feature-card-desc">{{ spec.desc }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="!isSearching && activeProductTab !== 'storage' && activeProductTab !== 'security'"
                  class="dropdown-params"
                >
                  <div class="params-panel">
                    <div class="params-panel-header">
                      <div class="params-panel-title">{{ selectedProductName }}</div>
                      <p v-if="selectedProductDescription" class="params-panel-desc">{{ selectedProductDescription }}，详情见以下功能</p>
                    </div>

                    <div class="params-panel-body">
                      <div class="feature-cards-grid">
                        <div v-for="(spec, idx) in selectedProductSpecRows" :key="idx" class="feature-card">
                          <div class="feature-card-icon">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                              <polyline points="22 4 12 14.01 9 11.01"/>
                            </svg>
                          </div>
                          <div class="feature-card-content">
                            <div class="feature-card-title">{{ spec.title }}</div>
                            <div class="feature-card-desc">{{ spec.desc }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li
          :class="{ active: isComputeTowerRoute }"
          @mouseenter="scheduleDirectNav('/compute-tower')"
          @mouseleave="clearDirectNavTimer"
        >
          <router-link to="/compute-tower" :class="{ active: isComputeTowerRoute }">应用场景</router-link>
        </li>
        <li class="has-dropdown"
            @mouseenter="showSolutionNewDropdown"
            @mouseleave="handleSolutionMouseLeave"
            :class="{ 'active': isSolutionRoute }">
          <a href="#" @click.prevent="onSolutionMenuClick">解决方案</a>
          <div
            class="dropdown-menu product-dropdown solution-product-dropdown product-dropdown--no-params"
            v-show="isSolutionNewDropdownOpen"
            @mouseenter="showSolutionNewDropdown"
            @mouseleave="handleSolutionMouseLeave"
          >
            <div class="dropdown-inner-container">
              <div class="dropdown-tabs">
                <div
                  v-for="tab in solutionNavTabs"
                  :key="tab.id"
                  class="tab-header"
                  :class="{ active: activeSolutionTab === tab.id }"
                  @click="setActiveSolutionTab(tab.id)"
                  @mouseenter="setActiveSolutionTab(tab.id)"
                >
                  <svg v-if="tab.id === 'cloud_security'" class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M19 11H5a4 4 0 0 0-4 4v0a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v0a4 4 0 0 0-4-4z"/>
                    <path d="M12 11V7"/>
                    <circle cx="12" cy="5" r="2"/>
                  </svg>
                  <svg v-else-if="tab.id === 'infrastructure'" class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z"/>
                  </svg>
                  <svg v-else-if="tab.id === 'ai'" class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                    <path d="M2 17l10 5 10-5"/>
                    <path d="M2 12l10 5 10-5"/>
                  </svg>
                  <svg v-else class="tab-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    <path d="M9 12l2 2 4-4"/>
                  </svg>
                  <span>{{ tab.title }}</span>
                </div>
              </div>
              <div class="dropdown-middle security-grid-layout">
                <div class="dropdown-products-area">
                  <div class="dropdown-content">
                    <div class="tab-content active">
                      <h3 class="section-title">{{ currentSolutionTabTitle }}</h3>
                      <div class="product-items-container">
                        <div
                          v-for="item in currentSolutionItems"
                          :key="item.path"
                          class="product-item"
                          :class="{ 'product-item-selected': selectedSolution && selectedSolution.path === item.path }"
                          @mouseenter="selectSolution(item)"
                          @mousedown.prevent="navigateToSolution(item.path)"
                        >
                          <div class="product-item-content">
                            <h4>{{ item.name }}</h4>
                            <p v-if="item.description">{{ item.description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li
          :class="{ active: isSuccessCasesRoute }"
          @mouseenter="scheduleDirectNav('success-cases')"
          @mouseleave="clearDirectNavTimer"
        >
          <router-link to="/#success-cases" :class="{ active: isSuccessCasesRoute }" @click="onSuccessCasesNav">成功案例</router-link>
        </li>
        <!--
        <li class="has-dropdown" 
            @mouseover="showServiceDropdown" 
            @mouseleave="hideServiceDropdown" 
            :class="{ 'active': isServiceRoute }">
          <router-link to="/">服务与支持</router-link>
          <div class="dropdown-menu service-dropdown" v-show="isServiceDropdownOpen">
            <div class="dropdown-inner-container">
              <div class="service-items-container">
                <router-link to="/services/security-tech" class="service-item" :class="{ 'active': activeServiceItem === '/services/security-tech' }">安全技术服务</router-link>
                <router-link to="/services/security-consulting" class="service-item" :class="{ 'active': activeServiceItem === '/services/security-consulting' }">安全咨询服务</router-link>
                <router-link to="/services/security-training" class="service-item" :class="{ 'active': activeServiceItem === '/services/security-training' }">安全培训服务</router-link>
              </div>
            </div>
          </div>
        </li>
        -->
        <li
          :class="{ active: isAboutRoute }"
          @mouseenter="scheduleDirectNav('/about-us')"
          @mouseleave="clearDirectNavTimer"
        >
          <router-link to="/about-us" :class="{ 'active': isAboutRoute }">了解瑞和云图</router-link>
        </li>
      </ul>
      
      <div class="actions">
        <div class="search-box" @click="openGlobalSearch">
          <i class="search-icon"></i>
          <span class="search-placeholder">搜索产品、解决方案...</span>
          <!-- <span class="search-shortcut">⌘K</span> -->
        </div>
        <!-- <div v-if="!isLoggedIn" class="auth-buttons">
          <router-link to="/login" class="login-btn">登录</router-link>
          <router-link to="/register" class="register-btn">免费注册</router-link>
        </div>
        <div v-else class="user-menu">
          <span class="welcome-text">欢迎，{{ currentUser?.username }}</span>
          <button @click="showLogoutConfirm = true" class="logout-btn">退出</button>
        </div> -->
      </div>
    </div>
  </nav>
  
  <!-- 退出确认对话框 -->
  <ConfirmDialog
    :visible="showLogoutConfirm"
    title="提示"
    message="真的要注销登录吗?"
    confirmText="确 认"
    cancelText="取 消"
    @confirm="handleLogout"
    @cancel="showLogoutConfirm = false"
  />
  
  <!-- 全局搜索 -->
  <GlobalSearch
    :visible="isGlobalSearchOpen"
    @close="closeGlobalSearch"
  />
</template>

<script>
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import GlobalSearch from '@/components/GlobalSearch.vue'

// 产品数据
import p1 from '@/assets/products/PIcon/p1.png'
import p2 from '@/assets/products/PIcon/p2.png'
import p3 from '@/assets/products/PIcon/p3.png'
import p4 from '@/assets/products/PIcon/p4.png'
import p5 from '@/assets/products/PIcon/p5.png'
import p6 from '@/assets/products/PIcon/p6.png'
import p7 from '@/assets/products/PIcon/p7.png'
import p8 from '@/assets/products/PIcon/p8.png'
import p9 from '@/assets/products/PIcon/p9.png'
import p10 from '@/assets/products/PIcon/10.png'
import p11 from '@/assets/products/PIcon/11.png'
import p12 from '@/assets/products/PIcon/12.png'
import p13 from '@/assets/products/PIcon/13.png'
import p14 from '@/assets/products/PIcon/14.png'
import p15 from '@/assets/products/PIcon/15.png'
import p16 from '@/assets/products/PIcon/16.png'
import {
  storageSpecMap as nasStorageSpecMap,
  storageRows as nasStorageRows,
} from '@/data/nasStorageContent.js'
import { solutionsData } from '@/data/solutionsData.js'
import { aiComputeSolutions } from '@/data/aiComputeSolutions.js'
import { edgeInfrastructureSolutions } from '@/data/edgeInfrastructureSolutions.js'
import { aiApplicationSolutions } from '@/data/aiApplicationSolutions.js'

const EDGE_SOLUTION_KEYS = {
  'ai-infrastructure-solution': 'ai-infrastructure',
  'edge-computing': 'edge-computing',
  'vm-container-fusion-infrastructure': 'vm-container-fusion',
  'database-cloud-infrastructure': 'database-cloud',
  'compute-network-infrastructure': 'compute-network-infrastructure'
}

const SOLUTION_PAGE_ADVANTAGES = {
  '/solutions/private-cloud-security': [
    { title: '统一管理' },
    { title: '统一运维' },
    { title: '按需扩展' },
    { title: '满足安全合规要求' },
    { title: '安全可管可控' }
  ],
  '/solutions/industry-government-cloud-security': [
    { title: '全流程纵深防护，保障政务安全' },
    { title: '合规适配性强，降低整改成本' },
    { title: '集约化管控，提升运维效率' },
    { title: '灵活可扩展，适配业务增长' }
  ],
  '/solutions/large-institution-internet-egress-sslo': [
    { title: '提升效率' },
    { title: '解密流量检测分析' },
    { title: '提升业务持续性' },
    { title: '安全能力平滑扩容' }
  ],
  '/solutions/carrier-dedicated-line-security': [
    { title: '攻击可视化' },
    { title: '流量可视化' },
    { title: '漏洞检测' },
    { title: '安全防护' }
  ],
  '/solutions/sase-security-solution': [
    { title: '架构协同保障' },
    { title: '部署灵活适配' },
    { title: '统一管控合规' },
    { title: '降本增效平衡' }
  ],
  '/solutions/low-cost-security-for-small-and-medium-systems': [
    { title: '软硬件一体、快速合规' },
    { title: '灵活扩展、按需选择' },
    { title: '统一管理、安全闭环' },
    { title: '简化操作、高效运维' }
  ],
  '/solutions/comprehensive-xinchuang': [
    { title: '国产CPU兼容' },
    { title: '国产操作系统适配' },
    { title: '硬件性能优化' },
    { title: '国产软件支持' },
    { title: '安全生态构建' },
    { title: '全栈协同优化' }
  ],
  '/product/ai-agent-application': [
    { title: '云边端协同' },
    { title: '边缘视觉识别' },
    { title: '分级告警处置' },
    { title: '模型持续适配' }
  ]
}

const SOLUTION_EXTRA_DESC = {
  '/solutions/ai-native-platform': '用于生产和治理可审计、可托管的智能体',
  '/product/ai-agent-application': '把智能体能力交付到具体业务场景'
}

function cleanAdvantageTitle(title) {
  return String(title || '')
    .replace(/^[（(][一二三四五六七八九十0-9]+[)）]\s*/, '')
    .replace(/^\d+[\.、．]\s*/, '')
    .trim()
}

function toAdvantageTitles(list) {
  const seen = new Set()
  const rows = []
  for (const item of list || []) {
    const title = cleanAdvantageTitle(typeof item === 'string' ? item : item?.title)
    if (!title || seen.has(title)) continue
    seen.add(title)
    const desc = typeof item === 'object' && item
      ? (item.desc || item.description || item.summary || '')
      : ''
    rows.push({ title, desc })
  }
  return rows
}

function lookupSolutionAdvantages(path) {
  const slug = path.split('/').filter(Boolean).pop()
  const edgeKey = EDGE_SOLUTION_KEYS[slug]
  const fromPage = SOLUTION_PAGE_ADVANTAGES[path]
  const fromEdge = edgeKey ? edgeInfrastructureSolutions[edgeKey]?.advantages : null
  const fromAiCompute = aiComputeSolutions[slug]?.advantages
  const fromAiApp = aiApplicationSolutions[slug]?.advantages
  const fromCapabilities = solutionsData[slug]?.capabilities
  return toAdvantageTitles(fromPage || fromEdge || fromAiCompute || fromAiApp || fromCapabilities || [])
}

function enrichSolutionItem(name, path) {
  const slug = path.split('/').filter(Boolean).pop()
  const data = solutionsData[slug]
  const description = data?.description || SOLUTION_EXTRA_DESC[path] || ''
  return { id: slug || path, name, path, description, specs: lookupSolutionAdvantages(path) }
}

export default {
  name: 'Navbar',
  components: {
    ConfirmDialog,
    GlobalSearch
  },
  data() {
    return {
      activeProductTab: 'cloud_computing',
      isSearchBoxDropdownOpen: false,
      isProductDropdownOpen: false,
      isSolutionNewDropdownOpen: false,
      activeSolutionTab: 'cloud_security',
      selectedSolution: null,
      isServiceDropdownOpen: false,
      showLogoutConfirm: false,
      isGlobalSearchOpen: false,
      productSearchKeyword: '',
      isProductSearchFocused: false,
      activeSolutionItem: null,
      activeProductItem: null,
      selectedProduct: null,
      activeServiceItem: null,
      lastSelectedProductTab: null,
      productDropdownHideTimer: null,
      solutionDropdownHideTimer: null,
      keepProductDropdownOpen: false,
      keepSolutionDropdownOpen: false,
      directNavTimer: null,
      // 移动端菜单状态
      isMobileMenuOpen: false,
      mobileAccordion: null, // 当前展开的手风琴: 'product' | 'solution' | 'service' | null
      mobileProductTab: 'cloud_computing', // 移动端产品分类tab
      mobileSolutionTab: 'cloud_security', // 移动端解决方案分类tab
      showStorageProducts: false,
      // 热门产品
      hotProducts: [
        { id: 'hot-1', name: '云安全资源池', description: '安全能力池化，为租户/业务按需提供防护能力', icon: p1, path: '/product/cloud-security-resource-pool', category: '热门产品' },
        { id: 'hot-2', name: '流量编排器', description: '智能流量编排，业务路径重塑', icon: p3, path: '/product/sslo', category: '热门产品' },
        { id: 'hot-3', name: '智算云', description: '通算智算一体，算力切分调度', icon: p4, path: '/product/edge-cloud/cloud-host', category: '热门产品' },
        { id: 'hot-4', name: 'SASE安全', description: 'SASE网关即插即用', icon: p2, path: '/product/sase', category: '热门产品' },
        { id: 'hot-token', name: 'AI Token 网关', description: '智能、统一、安全的企业级模型服务入口', icon: p16, path: '/product/ai-token-gateway', category: '热门产品' },
        { id: 'hot-5', name: 'AI 推理平台', description: '提供从IaaS、PaaS、MaaS的完整能力', icon: p16, path: '/product/ai-computing-platform', category: '热门产品' },
        { id: 'hot-6', name: 'AI native 平台', description: '用于生产和治理可审计、可托管的智能体', icon: p15, path: '/product/ai-native-platform', category: '热门产品' },
        { id: 'hot-7', name: 'AI SOC', description: '面向智能安全运营的海量数据自动化分析与报告平台', icon: p4, path: '/product/hyper-converged-cloud', category: '热门产品' },
        { id: 'hot-7b', name: 'AI 场景智能应用', description: '把智能体能力交付到具体业务场景', icon: p16, path: '/product/ai-agent-application', category: '热门产品' },
        { id: 'hot-8', name: '等保一体机', description: '集等保二级、三级安全能力一体，满足快速合规要求', icon: p7, path: '/product/equal-protection-appliance', category: '热门产品' }
      ],
      // 安全产品
      securityProducts: [
        { id: 'sec-1', name: '下一代防火墙', description: '网络运行可靠稳定和业务数据安全无忧', icon: p8, path: '/product/next-gen-firewall', category: '安全产品' },
        { id: 'sec-2', name: 'Web应用防火墙', description: '提供SQL 注入、XSS 跨站等 Web 攻击防护能力，防护网页业务安全', icon: p9, path: '/product/web-application-firewall', category: '安全产品' },
        { id: 'sec-3', name: '运维审计系统', description: '提升用户IT管理的安全和效益', icon: p10, path: '/product/ops-audit', category: '安全产品' },
        { id: 'sec-4', name: '日志审计系统', description: '集中采集分析全网各类日志，统一分析溯源、合规留存并预警异常行为', icon: p11, path: '/product/log-audit', category: '安全产品' },
        { id: 'sec-5', name: '脆弱性扫描系统与管理系统', description: '自动探测网络及系统软漏洞，精准发现安全漏洞并提供修复建议', icon: p12, path: '/product/vulnerability-scanner', category: '安全产品' },
        { id: 'sec-6', name: '数据库审计综合管理系统', description: '全程审计数据库访问与操作行为，精准审计风险操作', icon: p13, path: '/product/database-audit', category: '安全产品' },
        { id: 'sec-7', name: '主机安全管理系统', description: '新一代主机安全防护系统', icon: p14, path: '/product/host-security-management', category: '安全产品' },
        { id: 'sec-8', name: '全流量', description: '实时抓取全网原始流量，深度解析溯源，精准发现隐蔽威胁与异常行为。', icon: p3, path: '/product/full-traffic', category: '安全产品' },
        { id: 'sec-9', name: '量子密钥管理系统', description: '统一管控量子密钥全生命周期，实现密钥分发、存储调度与安全协同应用。', icon: p7, path: '/product/quantum-key-management', category: '安全产品' }
      ],
      // AI智算产品
      cloudComputingProducts: [
        { id: 'ai-token', name: 'AI Token 网关', description: '智能、统一、安全的企业级模型服务入口', icon: p16, path: '/product/ai-token-gateway', category: 'AI智算' },
        { id: 'ai-1', name: 'AI 推理平台', description: '提供从IaaS、PaaS、MaaS的完整能力', icon: p16, path: '/product/ai-computing-platform', category: 'AI智算' },
        { id: 'ai-2', name: 'AI native 平台', description: '用于生产和治理可审计、可托管的智能体', icon: p15, path: '/product/ai-native-platform', category: 'AI智算' },
        { id: 'ai-3', name: 'AI 场景智能应用', description: '把智能体能力交付到具体业务场景', icon: p16, path: '/product/ai-agent-application', category: 'AI智算' },
        { id: 'ai-4', name: 'AI SOC', description: '面向智能安全运营的海量数据自动化分析与报告平台', icon: p4, path: '/product/hyper-converged-cloud', category: 'AI智算' }
      ],
      // 云基础设施产品
      edgeCloudProducts: [
        {
          id: 'edge-1',
          name: '超融合',
          description: '存算一体，提供计算、存储、网络虚拟化',
          icon: p4,
          path: '/product/edge-cloud/containers',
          category: '云基础设施',
          specs: [
            '资源池底座上的容器服务：支持在 Cloudmap 资源池统一底座上交付 Kubernetes 工作负载集群。',
            '容器集群生命周期：支持版本升级、引擎参数与节点池运维，提供统一模板与基线配置。',
            '身份与 RBAC：支持 LDAP、OIDC 等身份源，支持集群/项目/命名空间多维角色绑定。',
            '项目与多租户边界：支持资源配额与网络策略入口，划分团队与业务边界。',
            '内置 Harbor 镜像仓库：支持多项目与 RBAC、镜像复制同步、漏洞扫描与垃圾回收策略。'
          ]
        },
        {
          id: 'edge-2',
          name: '边缘云',
          description: '小型边缘节点，可提供多租户、多VPC云化能力',
          icon: p5,
          path: '/product/edge-cloud-platform',
          category: '云基础设施',
          specs: [
            '云网安一体：多租户、跨区域组网轻量化云基座。',
            '弹性算力：云服务器/容器/裸金属多形态。',
            '内生安全：风火墙/WAF/EDR服务链编排。',
            '统一运维：租户管理、商品订单、监控告警。',
            '信创兼容：国产CPU与操作系统适配。'
          ]
        },
        {
          id: 'edge-4',
          name: '智算云',
          description: '通算智算一体，算力切分调度',
          icon: p5,
          path: '/product/edge-cloud/cloud-host',
          category: '云基础设施',
          specs: [
            '通算智算一体化融合底座：通用与智能算力统一池化管控，一套平台承载传统业务与 AI 业务。',
            '精细化算力切分与弹性调度：GPU/NPU 细粒度切片，支持优先级调度、资源抢占与在离线混部。',
            '多形态算力服务输出：云主机、容器、裸金属多形态交付，公共/专属算力池灵活切换。',
            '云原生安全与运维一体化：安全资源池与可视化运维，满足政企等保合规要求。'
          ]
        }
      ],
      // 算力网络产品
      computeNetworkProducts: [
        {
          id: 'network-1',
          name: 'SD-WAN',
          description: '跨域互联、传输加速、基于业务构建动态overlay网络',
          icon: p6,
          path: '/product/compute-network/interconnect',
          category: '算力网络',
          specs: [
            '网际路由器（VR）：实例管理、专家模式与跨域路由策略。',
            '角色模式：PE / CE / 标准 / SASE 等场景化网络角色配置。',
            '隧道与 VPN：SRv6 隧道与多种 VPN 能力，支撑灵活业务编排。',
            '能力范围：详见专题页「SD-WAN」完整能力清单。'
          ]
        },
        {
          id: 'network-2',
          name: '多云管理',
          description: '统一纳管多云、多数据中心资源，实现集中管控、资源调度、成本管控与运维一体化。',
          icon: p6,
          path: '/product/multi-cloud-management',
          category: '算力网络'
        },
        {
          id: 'network-4',
          name: 'TB级智能流量筛选',
          description: '按需自动化筛选流量',
          icon: p4,
          path: '/product/compute-network/ecosystem',
          category: '算力网络',
          specs: [
            '生态总览：多云管理、SD-WAN与安全资源池的协同关系示意。',
            '嵌入说明：原页面通过 ecosystem.html 展示生态图；请将同名静态页置于站点 public 目录以完整还原。',
            '能力范围：详见专题页「TB级智能流量筛选」嵌入区。'
          ]
        }
      ],
      // 云安全产品
      cloudSecurityProducts: [
        { id: 'cloud-1', name: '云安全资源池', description: '安全能力池化，为租户/业务按需提供防护能力', icon: p1, path: '/product/cloud-security-resource-pool', category: '云安全' },
        { id: 'cloud-2', name: '流量编排器', description: '智能流量编排，业务路径重塑', icon: p3, path: '/product/sslo', category: '云安全' },
        { id: 'cloud-3', name: '等保一体机', description: '集等保二级、三级安全能力一体，满足快速合规要求', icon: p7, path: '/product/equal-protection-appliance', category: '云安全' }
      ],
      storageProducts: [
        { id: 'sto-sw', name: '芯存 XNAS 软件', description: '新一代智能存储操作系统', icon: p1, path: '/product/storage/software', category: '存储' },
        { id: 'sto-3000', name: 'XC-3000 系列全闪 NAS', description: '信创机架式全闪旗舰，NVMe 与 NVMe-oF 低时延，适配高性能数据库、金融与媒体等场景。', icon: p1, path: '/product/storage/xc-3000', category: '存储' },
        { id: 'sto-2000', name: 'XC-2000 系列高性能 NAS', description: '大型企业全场景存储中枢，双路 CPU、混合架构，超高 IOPS 与 PB 级扩展。', icon: p1, path: '/product/storage/xc-2000', category: '存储' },
        { id: 'sto-1000', name: 'XC-1000 系列机架式 NAS', description: '部门与中型业务，MRSS V3、多盘位与扩展柜，兼顾性价比与可靠性。', icon: p1, path: '/product/storage/xc-1000', category: '存储' },
        { id: 'sto-08', name: 'XC-08 桌面信创 NAS', description: '小巧安静高性能，多硬件平台与信创存储 OS，适合办公共享、热备等。', icon: p1, path: '/product/storage/xc-08', category: '存储' }
      ],
      nasStorageRows: nasStorageRows,
      solutionNavTabs: [
        {
          id: 'cloud_security',
          title: '云安全专题',
          items: [
            enrichSolutionItem('私有云安全解决方案', '/solutions/private-cloud-security'),
            enrichSolutionItem('行业云/政务云安全解决方案', '/solutions/industry-government-cloud-security'),
            enrichSolutionItem('互联网出口安全解决方案', '/solutions/large-institution-internet-egress-sslo'),
            enrichSolutionItem('运营商安全解决方案', '/solutions/carrier-dedicated-line-security'),
            enrichSolutionItem('SASE安全解决方案', '/solutions/sase-security-solution'),
            enrichSolutionItem('中小系统低成本安全解决方案', '/solutions/low-cost-security-for-small-and-medium-systems')
          ]
        },
        {
          id: 'infrastructure',
          title: '云基础设施专题',
          items: [
            enrichSolutionItem('AI基础设施解决方案', '/solutions/ai-infrastructure-solution'),
            enrichSolutionItem('边缘计算解决方案', '/solutions/edge-computing'),
            enrichSolutionItem('超融合解决方案', '/solutions/vm-container-fusion-infrastructure'),
            enrichSolutionItem('Paas服务解决方案', '/solutions/database-cloud-infrastructure'),
            enrichSolutionItem('算力网络解决方案', '/solutions/compute-network-infrastructure')
          ]
        },
        {
          id: 'ai',
          title: 'AI应用专题',
          items: [
            enrichSolutionItem('AI 算力平台解决方案', '/solutions/ai-platform'),
            enrichSolutionItem('AI native 平台解决方案', '/solutions/ai-native-platform'),
            enrichSolutionItem('AI场景智能应用解决方案', '/product/ai-agent-application'),
            enrichSolutionItem('AI加持威胁情报解决方案', '/solutions/ai-threat-intel'),
            enrichSolutionItem('云边大小模型协同解决方案', '/solutions/cloud-edge-model-collaboration'),
            enrichSolutionItem('边缘CV应用解决方案', '/solutions/edge-cv-security'),
            enrichSolutionItem('车联网AI攻防靶场解决方案', '/solutions/vehicle-ai-offense-defense-range')
          ]
        },
        {
          id: 'xinchuang',
          title: '信创专题',
          items: [
            enrichSolutionItem('全面拥抱信创解决方案', '/solutions/comprehensive-xinchuang')
          ]
        }
      ],
      // 产品参数（用于右侧参数面板）- 精简版
      productSpecMap: {
        '/product/equal-protection-appliance': [
          { title: '等保套餐', desc: '二级/三级套餐，含NGFW、堡垒机、EDR、WAF等' },
          { title: '高可靠性', desc: '双机热备、集群部署，保障业务连续性' },
          { title: '态势感知', desc: '资产攻防、脆弱性、暴露面态势统计' },
          { title: '统一运营', desc: '安全能力统一管理、配置与运维' }
        ],
        '/product/next-gen-firewall': [
          { title: '基础FW', desc: '访问控制、入侵防御、病毒/URL/应用过滤' },
          { title: 'VPN功能', desc: 'IPSEC/SSL VPN、VXLAN、GRE隧道' },
          { title: 'QoS功能', desc: '用户限额与流量精细控制' },
          { title: '负载均衡', desc: '七元组/域名/接口组链路负载策略' }
        ],
        '/product/web-application-firewall': [
          { title: '基础防护', desc: '泛域名防护、HTTP2、一键断网' },
          { title: '状态监控', desc: '协议连接、系统状态、资产安全实时监控' },
          { title: '访问控制', desc: '黑白名单、IP/地域/HTTP访问控制' },
          { title: '安全防御', desc: 'SQL注入、XSS跨站、防暴力破解' }
        ],
        '/product/ops-audit': [
          { title: '多因子认证', desc: '手机令牌、USBKey、微信小程序' },
          { title: '资源管理', desc: 'SSH、RDP、VNC、Telnet、MySQL等协议' },
          { title: '策略管理', desc: '细粒度访问控制与文件传输控制' },
          { title: '审计日志', desc: '实时终断、在线/离线回放、传输记录' }
        ],
        '/product/log-audit': [
          { title: '事件采集', desc: 'Syslog、JDBC、Agent、Kafka多方式' },
          { title: '态势总览', desc: '平台运行、事件告警全局监控' },
          { title: '资产探查', desc: '可视化关联分析操作行为' },
          { title: '事件关联', desc: '多事件历史关联自动分析' }
        ],
        '/product/vulnerability-scanner': [
          { title: '主机扫描', desc: 'Windows/Linux/应用/数据库/网络设备' },
          { title: '数据库扫描', desc: '国产/非国产数据库授权与非授权扫描' },
          { title: '基线核查', desc: 'OS/中间件/数据库/设备配置核查' },
          { title: '等保合规', desc: '等保测评任务与报告导出' }
        ],
        '/product/database-audit': [
          { title: '数据库支持', desc: 'MySQL、Oracle、达梦、人大金仓等' },
          { title: '实时监控', desc: '运行状态、会话、连接数监视' },
          { title: '轨迹分析', desc: '网络图展示访问轨迹与异常检测' },
          { title: '风险评估', desc: '漏洞扫描与趋势分析' }
        ],
        '/product/host-security-management': [
          { title: '病毒扫描', desc: '全盘/快速/自定义多种扫描模式' },
          { title: '实时防御', desc: '文件、进程、网络实时监控' },
          { title: '资产采集', desc: '硬件、进程、网络、账号信息' },
          { title: '终端管控', desc: '网络/外设/远程协助管控' }
        ],
        '/product/full-traffic': [
          { title: '流量采集', desc: '全网原始流量实时抓取与还原' },
          { title: '深度解析', desc: '协议解析、会话还原与威胁识别' },
          { title: '溯源分析', desc: '攻击链路回溯与证据链沉淀' },
          { title: '威胁发现', desc: '隐蔽威胁与异常行为精准检出' }
        ],
        '/product/quantum-key-management': [
          { title: '密钥生成', desc: '量子真随机密钥生成与标识管理' },
          { title: '密钥分发', desc: '安全通道分发与多节点同步' },
          { title: '生命周期', desc: '更新、备份、撤销、归档全流程' },
          { title: '协同应用', desc: '对接业务系统提供密码服务' }
        ],
        '/product/sslo': [
          { title: '异构纳管', desc: 'x86/ARM物理机与安全网元统一管理' },
          { title: '服务链编排', desc: '拖拽式流量调度与安全策略配置' },
          { title: '智能调度', desc: '负载均衡与故障自动切换' },
          { title: '资源池化', desc: '按需分配、弹性扩展' }
        ],
        '/product/ai-token-gateway': [
          { title: '统一接入', desc: '本地/云端模型一个入口' },
          { title: '智能调度', desc: '按任务意图匹配模型' },
          { title: 'MCP 工具', desc: '联网搜索与企业工具调用' },
          { title: '安全审计', desc: '权限、额度、全链路追溯' }
        ],
        '/product/ai-computing-platform': [
          { title: '异构纳管', desc: 'CPU/GPU/国产加速硬件统一调度' },
          { title: '训练推理', desc: '支撑AI训练与推理业务高效运行' },
          { title: '弹性调度', desc: '算力按需分配、弹性扩缩容' },
          { title: '运维管控', desc: '全链路监控与多租户权限' }
        ],
        '/product/ai-native-platform': [
          { title: '智能体生产', desc: '构建、编排与版本管理' },
          { title: '可审计治理', desc: '全流程可追溯，满足合规要求' },
          { title: '可托管运行', desc: '托管环境与生命周期管理' },
          { title: '安全可控', desc: '权限隔离与运行态安全管控' }
        ],
        '/product/ai-agent-application': [
          { title: '场景交付', desc: '把智能体能力交付到具体业务' },
          { title: '工具调用', desc: '对接业务系统与外部工具链' },
          { title: '快速落地', desc: '客服、办公、运维等场景交付' },
          { title: '持续运营', desc: '效果评估、迭代优化与权限管控' }
        ],
        '/product/intelligent-traffic-screening': [
          { title: 'AI闭环', desc: '数据准备→训练→部署一站式流程' },
          { title: '多租户', desc: 'K8s容器化、权限控制与租户隔离' },
          { title: '智能标注', desc: '分布式训练、超参优化、模型压缩' },
          { title: '一键部署', desc: '模型发布、灰度发布、资产管理' }
        ],
        '/product/edge-cloud-platform': [
          { title: '云网安一体', desc: '多租户、跨区域组网轻量化云基座' },
          { title: '弹性算力', desc: '云服务器/容器/裸金属多形态' },
          { title: '内生安全', desc: '风火墙/WAF/EDR服务链编排' },
          { title: '统一运维', desc: '租户管理、商品订单、监控告警' },
          { title: '信创兼容', desc: '国产CPU与操作系统适配' }
        ],
        '/product/hyper-converged-cloud': [
          { title: '智能降噪', desc: '告警聚合去重、AI辅助研判' },
          { title: 'ATT&CK分析', desc: '攻击链分析、威胁溯源、处置建议' },
          { title: '自动化运营', desc: '日志采集→研判→报告全流程' },
          { title: '开放集成', desc: '威胁情报、AI大模型对接' }
        ],
        '/product/multi-cloud-management': [
          { title: '资源管控', desc: '云资源状态、实例、告警统一仪表盘' },
          { title: '权限管理', desc: '多租户隔离、RBAC角色权限' },
          { title: '跨域互联', desc: 'VR实例、SRv6隧道、跨区域连通' },
          { title: 'AI SOC', desc: '态势感知大屏与数据标准化' }
        ],
        '/product/cloud-security-resource-pool': [
          { title: '灵活编排', desc: '旁路/串流部署、SDN流量编排' },
          { title: '多云对接', desc: '标准API、第三方安全厂商适配' },
          { title: '全栈安全', desc: '边界/应用/主机/审计全能力' },
          { title: '高性能', desc: 'KVM+DPDK加速、分片路由SDN' },
          { title: '信创兼容', desc: '国产OS与CPU服务器部署' }
        ],
        '/product/sase': [
          { title: '集约安全', desc: '安全能力原子化、弹性扩展' },
          { title: 'SASE盒子', desc: '基础防护、传输加密一体化' },
          { title: '智能调度', desc: '边缘POP复用中心能力' },
          { title: '统一运维', desc: '加密隧道、集中分析与告警' }
        ],
        ...nasStorageSpecMap
      }
    };
  },
  computed: {
    selectedProductName() {
      return this.selectedProduct?.name || '';
    },
    selectedProductDescription() {
      return this.selectedProduct?.description || '';
    },
    selectedProductPath() {
      return this.selectedProduct?.path || '';
    },
    selectedProductSpecRows() {
      const productSpecs = this.selectedProduct?.specs;
      const path = this.selectedProduct?.path;
      const specs = (Array.isArray(productSpecs) && productSpecs.length)
        ? productSpecs
        : ((path && this.productSpecMap && this.productSpecMap[path]) ? this.productSpecMap[path] : []);
      // 如果已经是对象格式 { title, desc }，直接返回
      if (specs.length > 0 && typeof specs[0] === 'object' && specs[0].title) {
        return specs;
      }
      // 兼容旧的字符串格式
      return specs.map((line) => {
        if (typeof line === 'object' && line.title) {
          return line;
        }
        const idx = line.indexOf('：');
        if (idx > -1) {
          const title = line.slice(0, idx).trim();
          const desc = line.slice(idx + 1).trim();
          return { title, desc };
        }
        return { title: '', desc: line };
      });
    },
    currentSolutionTab() {
      return this.solutionNavTabs.find((tab) => tab.id === this.activeSolutionTab) || this.solutionNavTabs[0];
    },
    currentSolutionTabTitle() {
      return this.currentSolutionTab?.title || '';
    },
    currentSolutionItems() {
      return this.currentSolutionTab?.items || [];
    },
    currentMobileSolutionItems() {
      const tab = this.solutionNavTabs.find((item) => item.id === this.mobileSolutionTab)
        || this.solutionNavTabs[0];
      return tab?.items || [];
    },
    selectedSolutionName() {
      return this.selectedSolution?.name || '';
    },
    selectedSolutionDescription() {
      return this.selectedSolution?.description || '';
    },
    selectedSolutionSpecRows() {
      return this.selectedSolution?.specs || [];
    },
    solutionMaskHeight() {
      const count = this.currentSolutionItems.length;
      if (count <= 1) return 0;
      if (count <= 3) return 56;
      if (count <= 4) return 80;
      if (count <= 6) return 110;
      return 140;
    },
    // 是否处于搜索状态
    isSearching() {
      return this.productSearchKeyword.trim().length > 0;
    },
    // 是否处于解决方案路由
    isSolutionRoute() {
      return this.$route.path.includes('/solutions/');
    },
    // 是否处于AI智算路由
    isAIComputingRoute() {
      return [
        '/product/ai-token-gateway',
        '/product/ai-computing',
        '/product/ai-computing-platform',
        '/product/ai-native-platform',
        '/product/ai-agent-application',
        '/product/intelligent-traffic-screening',
        '/product/hyper-converged-cloud'
      ].includes(this.$route.path);
    },
    isHomeRoute() {
      return this.$route.path === '/' && this.$route.hash !== '#success-cases';
    },
    // 是否处于产品路由
    isProductRoute() {
      return this.$route.path.includes('/product/') && !this.isAIComputingRoute;
    },
    // 是否处于服务路由
    isServiceRoute() {
      return this.$route.path.includes('/services/');
    },
    // 是否处于关于我们路由
    isAboutRoute() {
      return this.$route.path === '/about-us';
    },
    isSuccessCasesRoute() {
      return this.$route.path === '/' && this.$route.hash === '#success-cases';
    },
    isComputeTowerRoute() {
      return this.$route.path === '/compute-tower' || this.$route.path.startsWith('/compute-tower/');
    },
    // 所有产品合并（去重）
    allProducts() {
      const all = [
        ...this.hotProducts,
        ...this.securityProducts,
        ...this.cloudComputingProducts,
        ...this.edgeCloudProducts,
        ...this.computeNetworkProducts,
        ...this.cloudSecurityProducts,
        ...(this.showStorageProducts ? this.storageProducts : [])
      ];
      // 根据 path 去重
      const seen = new Set();
      return all.filter(product => {
        if (seen.has(product.path)) {
          return false;
        }
        seen.add(product.path);
        return true;
      });
    },
    // 搜索过滤后的所有产品
    allFilteredProducts() {
      if (!this.productSearchKeyword.trim()) {
        return [];
      }
      const keyword = this.productSearchKeyword.toLowerCase().trim();
      return this.allProducts.filter(product => {
        return product.name.toLowerCase().includes(keyword) || 
               product.description.toLowerCase().includes(keyword);
      });
    },
    currentDropdownProductsCount() {
      if (this.isSearching) return this.allFilteredProducts.length;
      return this.getProductsByTab(this.activeProductTab).length;
    },
    productMaskHeight() {
      if (this.isSearching) return 0;
      /* 存储列表较短，底部渐变会压暗最后一项（XC-08），观感发虚 */
      if (this.activeProductTab === 'storage') return 0;
      if (this.activeProductTab === 'security') return 0;
      const count = this.currentDropdownProductsCount;
      if (count <= 3) return 56;
      if (count <= 4) return 80;
      if (count <= 6) return 110;
      return 140;
    },
    productDropdownHeight() {
      if (this.isSearching) return 700;
      if (this.activeProductTab === 'storage') return 780;
      const count = this.currentDropdownProductsCount;
      if (count <= 4) return 620;
      if (count <= 6) return 660;
      return 700;
    }
  },
  setup() {
    const authStore = useAuthStore()
    // 使用storeToRefs确保响应性
    const { isLoggedIn, currentUser } = storeToRefs(authStore)
    return { 
      authStore,
      isLoggedIn,
      currentUser
    }
  },
  methods: {
    onHomeNav() {
      this.closeMobileMenu();
      const goTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
      if (this.$route.path === '/' && this.$route.hash) {
        this.$router.replace({ path: '/' }).then(() => this.$nextTick(goTop));
        return;
      }
      this.$nextTick(goTop);
    },
    onSuccessCasesNav() {
      this.closeMobileMenu();
      if (this.$route.path !== '/') return;
      this.$nextTick(() => {
        document.getElementById('success-cases')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    scheduleDirectNav(target) {
      this.clearDirectNavTimer();
      this.hideProductDropdown();
      this.hideSolutionNewDropdown();
      this.directNavTimer = setTimeout(() => {
        this.directNavTimer = null;
        this.goDirectNav(target);
      }, 80);
    },
    clearDirectNavTimer() {
      if (this.directNavTimer) {
        clearTimeout(this.directNavTimer);
        this.directNavTimer = null;
      }
    },
    goDirectNav(target) {
      if (target === 'success-cases') {
        const scrollToCases = () => {
          window.setTimeout(() => {
            document.getElementById('success-cases')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 80);
        };
        if (this.$route.path === '/') {
          if (this.$route.hash !== '#success-cases') {
            this.$router.replace({ path: '/', hash: '#success-cases' }).then(scrollToCases).catch(() => scrollToCases());
            return;
          }
          scrollToCases();
          return;
        }
        this.$router.push({ path: '/', hash: '#success-cases' }).then(scrollToCases).catch(() => {
          this.$router.push('/success-cases').then(scrollToCases).catch(() => {});
        });
        return;
      }
      if (target === '/') {
        if (this.$route.path === '/') {
          this.onHomeNav();
          return;
        }
        this.$router.push('/').then(() => this.onHomeNav()).catch(() => this.onHomeNav());
        return;
      }
      if (this.$route.path === target) return;
      this.$router.push(target).catch(() => {});
    },
    setActiveProductTab(tab) {
      if (this.activeProductTab === tab) {
        if (!this.selectedProduct) this.selectFirstProductInTab(tab);
        return;
      }
      this.activeProductTab = tab;
      this.selectFirstProductInTab(tab);
    },
    onProductMenuClick() {
      // 点击顶部菜单“产品”：优先按当前路由回显对应产品
      this.isProductDropdownOpen = true;
      this.productSearchKeyword = '';
      this.syncProductSelectionByRoute(this.$route.path);
    },
    showProductDropdown() {
      this.clearDirectNavTimer();
      if (this.productDropdownHideTimer) {
        clearTimeout(this.productDropdownHideTimer);
      }
      if (this.solutionDropdownHideTimer) {
        clearTimeout(this.solutionDropdownHideTimer);
      }
      this.isSolutionNewDropdownOpen = false;
      if (!this.isProductDropdownOpen) {
        this.productSearchKeyword = '';
        this.syncProductSelectionByRoute(this.$route.path);
      }
      this.isProductDropdownOpen = true;
      if (this.selectedProduct?.path) {
        this.previewProductPage(this.selectedProduct.path);
      }
    },
    getTabByProductPath(path) {
      if (!path) return null;
      if (this.showStorageProducts && (path === '/product/storage' || path === '/product/storage/')) return 'storage';
      if (this.cloudSecurityProducts.some(p => p.path === path)) return 'cloud_security';
      if (this.cloudComputingProducts.some(p => p.path === path)) return 'cloud_computing';
      if (this.edgeCloudProducts.some(p => p.path === path)) return 'edge_cloud';
      if (this.computeNetworkProducts.some(p => p.path === path)) return 'compute_network';
      if (this.securityProducts.some(p => p.path === path)) return 'security';
      if (this.showStorageProducts && this.storageProducts.some(p => p.path === path)) return 'storage';
      if (this.hotProducts.some(p => p.path === path)) return 'hot';
      return null;
    },
    findProductByPath(path) {
      if (!path) return null;
      const allLists = [
        this.cloudSecurityProducts,
        this.cloudComputingProducts,
        this.edgeCloudProducts,
        this.computeNetworkProducts,
        this.securityProducts,
        this.storageProducts,
        this.hotProducts
      ];
      for (const list of allLists) {
        const match = list.find(p => p.path === path);
        if (match) return match;
      }
      return null;
    },
    syncProductSelectionByRoute(path) {
      const tab = this.getTabByProductPath(path);
      const currentProduct = this.findProductByPath(path);
      if (tab && currentProduct) {
        this.activeProductTab = tab;
        this.selectedProduct = currentProduct;
        return;
      }
      if (this.showStorageProducts && tab === 'storage' && (path === '/product/storage' || path === '/product/storage/')) {
        this.activeProductTab = 'storage';
        this.selectedProduct = this.storageProducts[0] || null;
        return;
      }
      // 非产品页或未命中时，默认展示 AI 智算第一个产品
      this.activeProductTab = 'cloud_computing';
      this.selectFirstProductInTab('cloud_computing');
    },
    // 根据当前路由设置产品tab
    setActiveTabByCurrentRoute() {
      const currentPath = this.$route.path;
      // 如果不在产品详情页，默认显示 AI 智算
      if (!currentPath.startsWith('/product/')) {
        this.activeProductTab = 'cloud_computing';
        this.lastSelectedProductTab = null;
        return;
      }
      // 如果有记录用户上次选择的tab，优先使用
      if (this.lastSelectedProductTab) {
        this.activeProductTab = this.lastSelectedProductTab;
        return;
      }
      // 否则根据产品所属分类设置tab（按优先级：热门产品 > 云安全 > 安全产品 > AI智算）
      // 热门产品
      if (this.hotProducts.some(p => p.path === currentPath)) {
        this.activeProductTab = 'hot';
        return;
      }
      // 云安全产品
      if (this.cloudSecurityProducts.some(p => p.path === currentPath)) {
        this.activeProductTab = 'cloud_security';
        return;
      }
      // 边缘云产品
      if (this.edgeCloudProducts.some(p => p.path === currentPath)) {
        this.activeProductTab = 'edge_cloud';
        return;
      }
      // 算力网络产品
      if (this.computeNetworkProducts.some(p => p.path === currentPath)) {
        this.activeProductTab = 'compute_network';
        return;
      }
      // 安全产品
      if (this.securityProducts.some(p => p.path === currentPath)) {
        this.activeProductTab = 'security';
        return;
      }
      // AI智算产品
      if (this.cloudComputingProducts.some(p => p.path === currentPath)) {
        this.activeProductTab = 'cloud_computing';
        return;
      }
      // 存储产品
      if (
        this.showStorageProducts &&
        (
          currentPath === '/product/storage' ||
          currentPath === '/product/storage/' ||
          this.storageProducts.some(p => p.path === currentPath)
        )
      ) {
        this.activeProductTab = 'storage';
        return;
      }
      // 未找到，默认 AI 智算
      this.activeProductTab = 'cloud_computing';
    },
    hideProductDropdown() {
      if (this.isProductSearchFocused) {
        return;
      }
      this.isProductDropdownOpen = false;
      this.productSearchKeyword = '';
      this.keepProductDropdownOpen = false;
    },
    handleProductMouseLeave() {
      if (this.productDropdownHideTimer) {
        clearTimeout(this.productDropdownHideTimer);
      }
      this.productDropdownHideTimer = setTimeout(() => {
        if (!this.isProductDropdownOpen || this.isSolutionNewDropdownOpen) {
          return;
        }
        this.hideProductDropdown();
      }, 100);
    },
    handleSolutionMouseLeave() {
      if (this.solutionDropdownHideTimer) {
        clearTimeout(this.solutionDropdownHideTimer);
      }
      this.solutionDropdownHideTimer = setTimeout(() => {
        if (!this.isSolutionNewDropdownOpen || this.isProductDropdownOpen) {
          return;
        }
        this.hideSolutionNewDropdown();
      }, 100);
    },
    handleProductSearchBlur() {
      window.setTimeout(() => {
        this.isProductSearchFocused = false;
      }, 150);
    },
    // 高亮搜索关键词
    highlightText(text) {
      if (!this.productSearchKeyword.trim()) {
        return text;
      }
      const keyword = this.productSearchKeyword.trim();
      const regex = new RegExp(`(${keyword})`, 'gi');
      return text.replace(regex, '<mark>$1</mark>');
    },
    // 清除搜索
    clearProductSearch() {
      this.productSearchKeyword = '';
    },
    /** 与 SmartX 类似：点击「存储」进入存储产品线总览页（PC 下拉 / 移动端产品 Tab 通用） */
    goToStorageLanding() {
      this.activeProductTab = 'storage';
      this.mobileProductTab = 'storage';
      this.navigateToProduct('/product/storage');
      this.closeMobileMenu();
    },
    /** 下拉/移动端内绿色横幅：进入 /product/storage 并关闭移动菜单 */
    goToStorageOverviewFromBanner() {
      this.navigateToProduct('/product/storage');
      this.closeMobileMenu();
    },
    // 导航到产品页
    navigateToProduct(path) {
      // 记录用户选择产品时所在的tab
      this.lastSelectedProductTab = this.activeProductTab;
      this.keepProductDropdownOpen = false;
      this.$router.push(path).catch(() => {});
      this.productSearchKeyword = '';
      // 关闭产品下拉菜单
      this.isProductDropdownOpen = false;
    },
    getProductsByTab(tab) {
      if (tab === 'hot') return this.hotProducts;
      if (tab === 'cloud_security') return this.cloudSecurityProducts;
      if (tab === 'cloud_computing') return this.cloudComputingProducts;
      if (tab === 'edge_cloud') return this.edgeCloudProducts;
      if (tab === 'compute_network') return this.computeNetworkProducts;
      if (tab === 'security') return this.securityProducts;
      if (tab === 'storage') return this.storageProducts;
      return [];
    },
    selectFirstProductInTab(tab) {
      const list = this.getProductsByTab(tab);
      if (list && list.length) {
        this.selectProduct(list[0]);
      } else {
        this.selectedProduct = null;
      }
    },
    selectProduct(product) {
      this.selectedProduct = product;
      if (product?.path && this.isProductDropdownOpen) {
        this.previewProductPage(product.path);
      }
    },
    previewProductPage(path) {
      if (!path || this.$route.path === path) return;
      this.keepProductDropdownOpen = true;
      this.lastSelectedProductTab = this.activeProductTab;
      const method = this.$route.path.startsWith('/product/') ? 'replace' : 'push';
      this.$router[method](path).catch(() => {});
    },
    selectStorageNavItem(path) {
      const p = this.storageProducts.find((x) => x.path === path);
      if (p) this.selectProduct(p);
    },
    shouldShowProductIcon() {
      // 产品下拉列表统一不显示左侧小图标
      return false;
    },
    filterProducts() {
      // 触发响应式更新，computed 会自动处理
    },
    showSolutionDropdown() {
      this.isSolutionDropdownOpen = true;
    },
    hideSolutionDropdown() {
      this.isSolutionDropdownOpen = false;
    },
    showSolutionNewDropdown() {
      this.clearDirectNavTimer();
      if (this.productDropdownHideTimer) {
        clearTimeout(this.productDropdownHideTimer);
      }
      if (this.solutionDropdownHideTimer) {
        clearTimeout(this.solutionDropdownHideTimer);
      }
      this.isProductDropdownOpen = false;
      if (!this.isSolutionNewDropdownOpen) {
        this.syncSolutionSelectionByRoute(this.$route.path);
      }
      this.isSolutionNewDropdownOpen = true;
      if (this.selectedSolution?.path) {
        this.previewSolutionPage(this.selectedSolution.path);
      }
    },
    hideSolutionNewDropdown() {
      if (this.solutionDropdownHideTimer) {
        clearTimeout(this.solutionDropdownHideTimer);
        this.solutionDropdownHideTimer = null;
      }
      this.isSolutionNewDropdownOpen = false;
      this.keepSolutionDropdownOpen = false;
    },
    onSolutionMenuClick() {
      this.isSolutionNewDropdownOpen = true;
      this.syncSolutionSelectionByRoute(this.$route.path);
    },
    setActiveSolutionTab(tabId) {
      if (this.activeSolutionTab === tabId) {
        if (!this.selectedSolution && this.isSolutionNewDropdownOpen) {
          const tab = this.solutionNavTabs.find((item) => item.id === tabId);
          const first = tab?.items?.[0] || null;
          if (first) this.selectSolution(first);
        }
        return;
      }
      this.activeSolutionTab = tabId;
      const tab = this.solutionNavTabs.find((item) => item.id === tabId);
      const first = tab?.items?.[0] || null;
      if (first) this.selectSolution(first);
      else this.selectedSolution = null;
    },
    selectSolution(item) {
      this.selectedSolution = item;
      if (item?.path && this.isSolutionNewDropdownOpen) {
        this.previewSolutionPage(item.path);
      }
    },
    previewSolutionPage(path) {
      if (!path || this.$route.path === path) return;
      this.keepSolutionDropdownOpen = true;
      const alreadyOnSolution = Boolean(
        this.findSolutionByPath(this.$route.path) || this.$route.path.startsWith('/solutions/')
      );
      const method = alreadyOnSolution ? 'replace' : 'push';
      this.$router[method](path).catch(() => {});
    },
    findSolutionByPath(path) {
      if (!path) return null;
      for (const tab of this.solutionNavTabs) {
        const match = tab.items.find((item) => item.path === path);
        if (match) return { tabId: tab.id, item: match };
      }
      return null;
    },
    syncSolutionSelectionByRoute(path) {
      const found = this.findSolutionByPath(path);
      if (found) {
        this.activeSolutionTab = found.tabId;
        this.selectedSolution = found.item;
        return;
      }
      this.activeSolutionTab = 'cloud_security';
      this.selectedSolution = this.solutionNavTabs[0]?.items?.[0] || null;
    },
    navigateToSolution(path) {
      this.keepSolutionDropdownOpen = false;
      this.$router.push(path).catch(() => {});
      this.isSolutionNewDropdownOpen = false;
    },
    showServiceDropdown() {
      this.isServiceDropdownOpen = true;
    },
    hideServiceDropdown() {
      this.isServiceDropdownOpen = false;
    },
    toggleSearchBox() {
      this.isSearchBoxOpen = !this.isSearchBoxOpen;
    },
    handleLogout() {
      this.authStore.logout()
      this.showLogoutConfirm = false
      this.$router.push('/')
    },
    openGlobalSearch() {
      this.isGlobalSearchOpen = true;
    },
    closeGlobalSearch() {
      this.isGlobalSearchOpen = false;
    },
    handleKeydown(e) {
      const target = e.target;
      const isEditableTarget =
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target?.isContentEditable;

      if (e.isComposing || isEditableTarget) {
        return;
      }

      // 支持 Cmd+K (Mac) 或 Ctrl+K (Windows/Linux) 打开搜索
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        this.isGlobalSearchOpen = !this.isGlobalSearchOpen;
      }
    },
    // 更新当前选中的解决方案项
    updateActiveSolutionItem(path) {
      if (path && path.includes('/solutions/')) {
        this.activeSolutionItem = path;
      } else {
        this.activeSolutionItem = null;
      }
    },
    // 更新当前选中的产品项
    updateActiveProductItem(path) {
      if (path && path.includes('/product/')) {
        this.activeProductItem = path;
      } else {
        this.activeProductItem = null;
      }
    },
    // 更新当前选中的服务项
    updateActiveServiceItem(path) {
      if (path && path.includes('/services/')) {
        this.activeServiceItem = path;
      } else {
        this.activeServiceItem = null;
      }
    },
    setActiveServiceItem(item) {
      this.activeServiceItem = item;
    },
    // 移动端菜单方法
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      // 打开菜单时禁止页面滚动
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
        this.mobileAccordion = null;
      }
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
      this.mobileAccordion = null;
      document.body.style.overflow = '';
    },
    toggleMobileAccordion(type) {
      if (this.mobileAccordion === type) {
        this.mobileAccordion = null;
      } else {
        this.mobileAccordion = type;
      }
    }
  },
  mounted() {
    this.authStore.initializeAuth();
    // 添加全局键盘事件监听
    window.addEventListener('keydown', this.handleKeydown);
    
    // 初始化当前选中的解决方案项、产品项和服务项
    this.updateActiveSolutionItem(this.$route.path);
    this.updateActiveProductItem(this.$route.path);
    this.updateActiveServiceItem(this.$route.path);
    this.syncProductSelectionByRoute(this.$route.path);
    this.syncSolutionSelectionByRoute(this.$route.path);
    
    // 监听路由变化
    this.$watch(
      () => this.$route.path,
      (newPath) => {
        this.updateActiveSolutionItem(newPath);
        this.updateActiveProductItem(newPath);
        this.updateActiveServiceItem(newPath);
        this.syncProductSelectionByRoute(newPath);
        this.syncSolutionSelectionByRoute(newPath);
        if (this.keepProductDropdownOpen) {
          this.keepProductDropdownOpen = false;
          return;
        }
        if (this.keepSolutionDropdownOpen) {
          this.keepSolutionDropdownOpen = false;
          return;
        }
        // 路由跳转后收起下拉，避免详情页仍盖着菜单
        this.hideSolutionNewDropdown();
        this.hideProductDropdown();
      }
    );
  },
  beforeUnmount() {
    this.clearDirectNavTimer();
    // 移除键盘事件监听
    window.removeEventListener('keydown', this.handleKeydown);
  }
};
</script>

<style scoped>

nav {
  display: flex;
  /* justify-content: center; */ /* Center the nav-inner-container */
  align-items: center;
  padding: 0; /* Remove padding from nav itself */
  background-color: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(238, 242, 246, 0.9);
  backdrop-filter: blur(12px);
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 60px;
}
/* .right-section removed */
.logo img {
  height: 42px;
}
.logo{
  height: 42px;
}
.logo a{
  display: inline-block;
  height: 42px;
}

/* SVG logo 样式 */
.nav-logo {
  height: 42px;
  width: auto;
  display: block;
  filter: saturate(1.75) contrast(1.14) brightness(1.06);
}

.mobile-nav-logo {
  height: 36px;
  width: auto;
  display: block;
  filter: saturate(1.75) contrast(1.14) brightness(1.06);
}
.actions {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.nav-links {
  display: flex;
  list-style: none;
  align-items: stretch;
  height: 100%;
}
.nav-links li {
  margin: 0;
  padding: 0 20px;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-links li:first-child {
  padding-left: 60px;
}
.nav-links a {
  text-decoration: none;
  color: #353f4e;
  padding: 0;
  display: flex;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0.02em;
  transition: color 0.2s ease;
  position: relative;
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: 16px;
  left: 50%;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #06b6d4);
  transition: all 0.3s ease;
  transform: translateX(-50%);
  border-radius: 1px;
}

.nav-links li a:hover::after,
.has-dropdown:hover > a::after {
  width: 100%;
}

.dropdown-menu {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  background: linear-gradient(180deg, #ffffff 0%, #fafbfc 50%, #f5f7fa 100%);
  box-shadow: 0 24px 60px -16px rgba(0, 0, 0, 0.12), 0 12px 28px -8px rgba(0, 0, 0, 0.08);
  border-top: 1px solid #eef2f6;
  z-index: 1001;
  padding: 0;
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  box-sizing: border-box;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.nav-links li a:hover {
  color: var(--color-primary);
}

.has-dropdown:hover > a {
  color: var(--color-primary);
}

.has-dropdown.active a,
.nav-links > li.active > a {
  color: var(--color-primary);
}

.dropdown-inner-container {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  gap: 0;
  align-items: stretch;
  flex: 1;
}

/* 产品下拉内层容器 */
.product-dropdown .dropdown-inner-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px 0 0;
  max-height: calc(var(--layout-vh, 100vh) - 80px);
  justify-content: flex-start;
  position: relative;
  display: flex;
  align-items: stretch;
}

.product-dropdown .dropdown-tabs,
.product-dropdown .dropdown-middle,
.product-dropdown .dropdown-params {
  position: relative;
  z-index: 1;
}

/* 产品列表区域 */
.dropdown-products-area {
  flex: 0 0 auto;
  padding-right: 0;
}

/* 自定义滚动条 */
.dropdown-products-area::-webkit-scrollbar {
  width: 6px;
}

.dropdown-products-area::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.dropdown-products-area::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.dropdown-products-area::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* 产品下拉高度自适应；文字仍按原宽度排，仅右侧留白铺同色底 */
.product-dropdown {
  min-height: 520px;
  height: auto;
  overflow: visible;
}

.product-dropdown::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: calc(50% + 800px - 24px);
  background: #f0f6ff;
  pointer-events: none;
  z-index: 0;
}

.product-dropdown--no-params::after {
  display: none;
}

.solution-product-dropdown .dropdown-tabs {
  width: 230px;
}

.dropdown-tabs {
  display: flex;
  flex-direction: column;
  width: 210px;
  padding: 32px 0;
  flex-shrink: 0;
  border-right: 1px solid #eef2f6;
  align-self: stretch;
}

.tab-header {
  padding: 16px 20px;
  cursor: pointer;
  font-weight: 500;
  color: #475569;
  text-align: left;
  font-size: 16px;
  line-height: 1.5;
  white-space: nowrap;
  margin: 4px 12px;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}

.tab-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  transition: all 0.3s ease;
}

.tab-header::before {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #94a3b8;
  transition: all 0.3s ease;
  flex-shrink: 0;
  display: none;
}

.tab-header:hover {
  color: #2563eb;
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f2ff 100%);
  transform: translateX(4px);
}

.tab-header:hover .tab-icon {
  color: #3b82f6;
}

.tab-header:hover::before {
  background: #3b82f6;
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.4);
}

.tab-header.active {
  color: #2563eb;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
  transform: translateX(4px);
}

.tab-header.active .tab-icon {
  color: #3b82f6;
}

.tab-header.active::before {
  width: 6px;
  height: 6px;
  background: linear-gradient(135deg, #3b82f6, #06b6d4);
  box-shadow: 0 0 10px rgba(59, 130, 246, 0.5);
}

.dropdown-middle {
  flex: 1;
  min-width: 620px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  align-self: stretch;
}

.dropdown-middle.security-layout {
  display: grid;
  grid-template-columns: 380px 1fr;
  grid-template-rows: 1fr;
  column-gap: 0;
  align-items: stretch;
  max-height: calc(var(--layout-vh, 100vh) - 80px);
  overflow-y: auto;
  align-self: stretch;
}

.dropdown-middle.non-security-layout {
  display: grid;
  grid-template-columns: 380px 1fr;
  grid-template-rows: 1fr;
  column-gap: 0;
  align-items: stretch;
  max-height: calc(var(--layout-vh, 100vh) - 80px);
  overflow-y: auto;
  align-self: stretch;
}

.dropdown-middle.security-layout .dropdown-products-area {
  min-width: 0;
  padding: 32px;
  border-right: 1px solid #eef2f6;
  align-self: stretch;
  background: transparent;
}

.dropdown-middle.non-security-layout .dropdown-products-area {
  min-width: 0;
  padding: 32px;
  border-right: 1px solid #eef2f6;
  align-self: stretch;
  background: transparent;
}

.dropdown-middle.security-layout .dropdown-params {
  width: 100%;
  padding: 24px;
  background: #f0f6ff;
  align-self: stretch;
}

.dropdown-middle.non-security-layout .dropdown-params {
  width: 100%;
  padding: 24px;
  background: #f0f6ff;
  align-self: stretch;
}

/* 存储下拉两栏布局 */
.dropdown-middle.storage-layout {
  grid-template-columns: 1fr;
}

.dropdown-middle.security-grid-layout {
  display: block;
  min-width: 0;
  max-height: calc(var(--layout-vh, 100vh) - 80px);
  overflow-y: auto;
}

.dropdown-middle.security-grid-layout .dropdown-products-area {
  min-width: 0;
  width: 100%;
  padding: 28px 36px 36px;
  border-right: none;
  background: transparent;
}

.dropdown-middle.security-grid-layout .dropdown-products-area::after {
  display: none;
}

.dropdown-middle.security-grid-layout .tab-content.active .product-items-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
  max-width: none;
  flex-direction: unset;
  flex-wrap: unset;
}

.dropdown-middle.security-grid-layout .tab-content.active .product-item {
  flex: none;
  width: auto;
  min-height: 116px;
  padding: 22px 20px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.dropdown-middle.security-grid-layout .product-item-arrow {
  display: none;
}

.dropdown-middle.storage-layout .dropdown-products-area {
  border-right: none;
  padding: 0;
}

.dropdown-middle.storage-layout .tab-content--storage {
  padding: 28px 36px;
}

.dropdown-middle.storage-layout .tab-content--storage > .section-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 20px;
  padding-bottom: 0;
  border-bottom: none;
}

/* 存储横幅框 - 使用 CSS mask 渐变边框 */
.dropdown-middle.storage-layout .storage-dd-smartx-cta {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  margin-bottom: 24px;
  border-radius: 12px;
  position: relative;
  background: #ffffff;
  border: none;
  cursor: pointer;
  transition: all 0.25s ease;
  box-sizing: border-box;
  width: 100%;
  text-decoration: none !important;
  overflow: visible;
}

.dropdown-middle.storage-layout .storage-dd-smartx-cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 12px;
  padding: 2px;
  background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);
  -webkit-mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  z-index: 0;
  transition: opacity 0.25s ease;
}

.dropdown-middle.storage-layout .storage-dd-smartx-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.25);
  background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);
}

.dropdown-middle.storage-layout .storage-dd-smartx-cta:hover::before {
  opacity: 0;
}

.dropdown-middle.storage-layout .storage-dd-smartx-cta__main {
  font-size: 15px;
  font-weight: 600;
  color: #1e40af;
  position: relative;
  z-index: 1;
  transition: color 0.25s ease;
}

.dropdown-middle.storage-layout .storage-dd-smartx-cta__hint {
  font-size: 14px;
  color: #64748b;
  flex: 1;
  margin-left: 12px;
  position: relative;
  z-index: 1;
  transition: color 0.25s ease;
}

.dropdown-middle.storage-layout .storage-dd-smartx-cta__arrow {
  color: #3b82f6;
  font-size: 16px;
  position: relative;
  z-index: 1;
  transition: color 0.25s ease, transform 0.25s ease;
}

.dropdown-middle.storage-layout .storage-dd-smartx-cta:hover .storage-dd-smartx-cta__main,
.dropdown-middle.storage-layout .storage-dd-smartx-cta:hover .storage-dd-smartx-cta__hint,
.dropdown-middle.storage-layout .storage-dd-smartx-cta:hover .storage-dd-smartx-cta__arrow {
  color: #ffffff;
}

.dropdown-middle.storage-layout .storage-dd-smartx-cta:hover .storage-dd-smartx-cta__arrow {
  transform: translateX(4px);
}

/* 存储两栏布局 */
.dropdown-middle.storage-layout .storage-dropdown-rows {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: none !important;
}

.dropdown-middle.storage-layout .storage-dd-row {
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 16px;
  align-items: start;
  width: 100%;
}

.dropdown-middle.storage-layout .storage-dd-label-col {
  padding-top: 10px;
  width: 80px;
}

.dropdown-middle.storage-layout .storage-dd-label {
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
}

.dropdown-middle.storage-layout .storage-dd-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  flex: 1;
  min-width: 0;
}

.dropdown-middle.storage-layout .storage-dd-group {
  margin-bottom: 6px;
  width: 100%;
}

.dropdown-middle.storage-layout .storage-dd-group-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 2px;
}

.dropdown-middle.storage-layout .storage-dd-group-desc {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
}

.dropdown-middle.storage-layout .storage-dd-item-wrap {
  width: 100%;
}

.dropdown-middle.storage-layout .storage-dd-item-main {
  width: 100%;
  display: block;
}

/* 存储产品卡片 - 参考云安全产品样式，使用 !important 覆盖旧样式 */
.dropdown-middle.storage-layout .tab-content--storage .product-item--storage {
  width: 100% !important;
  min-height: 72px !important;
  padding: 14px 16px !important;
  background: #ffffff !important;
  border: 1px solid #e8ecf1 !important;
  border-radius: 10px !important;
  cursor: pointer;
  transition: all 0.25s ease !important;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
  transform: none !important;
}

.dropdown-middle.storage-layout .tab-content--storage .product-item--storage:hover {
  background: #f8fbff !important;
  border-color: #2563eb !important;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.12), 0 2px 8px rgba(37, 99, 235, 0.08) !important;
  transform: translateY(-2px) !important;
}

.dropdown-middle.storage-layout .tab-content--storage .product-item--storage.product-item-selected {
  background: #f0f7ff !important;
  border-color: #2563eb !important;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1) !important;
  transform: none !important;
}

.dropdown-middle.storage-layout .tab-content--storage .product-item--storage-lead h4 {
  font-size: 15px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  -webkit-text-fill-color: #1e293b !important;
  margin-bottom: 6px !important;
  line-height: 1.4 !important;
}

.dropdown-middle.storage-layout .tab-content--storage .product-item--storage-lead p {
  font-size: 13px !important;
  color: #6b7280 !important;
  -webkit-text-fill-color: #6b7280 !important;
  line-height: 1.5 !important;
  margin: 0 !important;
  opacity: 1 !important;
}

.dropdown-middle.storage-layout .tab-content--storage .product-item--storage-model h4 {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  -webkit-text-fill-color: #1e293b !important;
  margin-bottom: 4px !important;
  line-height: 1.4 !important;
}

.dropdown-middle.storage-layout .tab-content--storage .product-item--storage-model p {
  font-size: 13px !important;
  color: #6b7280 !important;
  -webkit-text-fill-color: #6b7280 !important;
  line-height: 1.5 !important;
  margin: 0 !important;
  opacity: 1 !important;
}

.dropdown-middle.storage-layout .tab-content--storage .product-item--storage:hover h4,
.dropdown-middle.storage-layout .tab-content--storage .product-item--storage.product-item-selected h4 {
  color: #2563eb !important;
  -webkit-text-fill-color: #2563eb !important;
}

.dropdown-middle.storage-layout .tab-content--storage .product-item--storage:hover p,
.dropdown-middle.storage-layout .tab-content--storage .product-item--storage.product-item-selected p {
  color: #6b7280 !important;
  -webkit-text-fill-color: #6b7280 !important;
}

/* 存储：无右侧参数栏时中间区占满，避免仍落在窄列 */
.dropdown-middle.non-security-layout.storage-no-params {
  grid-template-columns: minmax(0, 1fr);
  border-right: none;
}

.dropdown-middle.non-security-layout.storage-no-params .tab-content--storage .storage-dropdown-rows {
  max-width: 100%;
}

.dropdown-middle.security-layout .params-panel {
  padding: 4px 10px 0 6px;
}

.dropdown-middle.security-layout .params-panel-header {
  padding: 4px 0 12px;
}

.dropdown-middle.security-layout .params-panel-body {
  padding-right: 2px;
}

.dropdown-middle.security-layout .params-spec-row {
  padding: 16px 8px 16px 0;
}

.dropdown-middle.security-layout .params-spec-label {
  width: 122px;
  padding-right: 8px;
}

.product-inline-panel {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eef2f7;
}

.product-inline-panel .params-panel {
  width: 100%;
  padding: 0;
  display: grid;
  grid-template-columns: minmax(240px, 360px) minmax(0, 1fr);
  gap: 22px;
}

.product-inline-panel .params-panel-header {
  gap: 10px;
}

.product-inline-panel .params-panel-title {
  font-size: 24px;
  line-height: 1.05;
}

.product-inline-panel .params-panel-subtitle {
  margin-top: 4px;
  margin-bottom: 0;
}

.product-inline-panel .params-panel-body {
  max-height: none;
  overflow-y: visible;
}

.dropdown-products-area {
  flex: 0 0 auto;
  overflow-y: visible;
  padding-top: 0;
  padding-left: 0;
  position: relative;
}

/* 产品列表下方渐隐遮罩：高度根据当前产品数量动态变化 */
.dropdown-products-area::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: var(--product-mask-height, 120px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.95) 100%);
  pointer-events: none;
  z-index: 1;
}

.dropdown-products-area.is-searching::after {
  display: none;
}

.dropdown-content {
  flex-grow: 1;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 0;
}

.section-title {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  text-align: left;
  letter-spacing: -0.02em;
  color: #1e293b;
  margin-bottom: 28px;
  padding-bottom: 16px;
  border-bottom: 2px solid rgba(238, 242, 246, 0.8);
}

/* 存储 Tab标题 */
.tab-content--storage > .section-title {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: #1e293b;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}

/* 存储 Tab：与 SmartX HCI「核心产品」区标题尺度接近；下方接绿框，再接软件/一体机 */
.tab-content--storage > .section-title {
  font-size: 26px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: #1e293b;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8ecf1;
}

/* 下拉菜单项样式重置 */
.product-items-container .product-item {
  color: var(--color-text) !important;
  text-decoration: none !important;
}

.product-item {
  /* 三列布局：每行 3 个卡片 */
  flex: 0 0 calc((100% - 32px) / 3);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: 16px;
  background: transparent;
  border: 1px solid rgba(226, 232, 240, 0.5);
  border-radius: 10px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  cursor: pointer;
  color: var(--color-text-secondary);
  box-shadow: none;
}

.product-item {
  flex: 0 0 calc((100% - 40px) / 3);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: 18px 16px;
  border: 1px solid rgba(238, 242, 246, 0.6);
  border-radius: 6px;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  cursor: pointer;
  color: var(--color-text-secondary);
  background: transparent;
  will-change: transform;
  backface-visibility: hidden;
  transform: translateZ(0);
}

.product-items-container.security-list .product-item {
  flex: 0 0 calc((100% - 60px) / 4);
}

.dropdown-middle.non-security-layout .tab-content.active .product-items-container {
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 12px;
  width: 100%;
  max-width: 480px;
}

.dropdown-middle.non-security-layout .tab-content.active .product-item {
  flex: 0 0 auto;
  width: 100%;
  min-height: 90px;
  padding: 24px 22px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.product-item-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.product-item-arrow {
  opacity: 0;
  transform: translateX(-8px);
  transition: all 0.25s ease;
  color: #3b82f6;
  flex-shrink: 0;
}

.product-item:hover .product-item-arrow {
  opacity: 1;
  transform: translateX(0);
}

.product-item:hover {
  background: linear-gradient(145deg, #f0f6ff 0%, #e5efff 100%);
  border-color: #3b82f6;
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(59, 130, 246, 0.15), 0 6px 20px rgba(59, 130, 246, 0.1);
}

.product-item-selected {
  background: #f0f6ff;
  border-color: #3b82f6;
  box-shadow: 0 10px 30px rgba(59, 130, 246, 0.12);
}

.product-item.active {
  background-color: var(--color-primary-soft);
}

.product-item img {
  width: 42px;
  height: 42px;
  margin-bottom: 16px;
  flex-shrink: 0;
  border-radius: 12px;
}

.product-item-content img {
  width: 42px;
  height: 42px;
  margin-bottom: 16px;
  flex-shrink: 0;
  border-radius: 12px;
}

.product-item h4 {
  font-size: 16px;
  margin-bottom: 8px;
  color: #1e293b;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.01em;
  transition: color 0.25s ease;
}

.product-item:hover h4,
.product-item-selected h4 {
  color: #2563eb;
}

.product-item p {
  font-size: 13px;
  color: #64748b !important;
  line-height: 1.65;
  margin: 0;
  padding-top: 0;
  text-align: left;
}

/* 存储下拉：对齐 SmartX HCI 核心产品区 — 参考 https://www.smartx.com/smartx-hci/ */
.tab-content--storage .storage-dropdown-rows {
  --storage-smartx-label: #888888;
  --storage-smartx-title: #0056b3;
  --storage-smartx-title-size: 20px;
  --storage-smartx-desc: #666666;
  --storage-smartx-desc-size: 14px;
  --storage-smartx-model-size: 15px;
  --storage-smartx-model-desc-size: 13px;

  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-top: 0;
}

.storage-dd-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
}

.storage-dd-label-col {
  flex: 0 0 56px;
  width: 56px;
  min-width: 56px;
  padding-top: 0;
}

.storage-dd-label {
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: var(--storage-smartx-label, #888888);
  letter-spacing: 0.01em;
  line-height: 1.45;
  white-space: nowrap;
}

.storage-dd-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 存储：SmartX 式绿条（标题下、分栏上） */
.storage-dd-smartx-cta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.2rem 0.6rem;
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 10px;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  text-decoration: none;
  color: #0f4a8a !important;
  background: #ffffff;
  border: 1px solid #17a56f;
  box-shadow: none;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  cursor: pointer;
}

.storage-dd-smartx-cta--under-title {
  margin: 0 0 14px;
  max-width: none;
}

.storage-dd-smartx-cta:hover {
  color: #0f4a8a !important;
  background: #f7fffb;
  border-color: #149866;
}

.storage-dd-smartx-cta__main {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #0056b3;
}

.storage-dd-smartx-cta__hint {
  flex: 1;
  min-width: 10rem;
  font-size: 10px;
  font-weight: 400;
  line-height: 1.35;
  color: #6b7280;
  opacity: 1;
}

.storage-dd-smartx-cta__arrow {
  font-size: 0.92rem;
  font-weight: 500;
  line-height: 1;
  color: #159a68;
  opacity: 1;
}

.storage-dd-group {
  padding: 0;
  margin: 0 0 2px;
  background: transparent;
  border-radius: 0;
  border: none;
}

.storage-dd-group-title {
  font-size: var(--storage-smartx-title-size, 20px);
  font-weight: 600;
  color: var(--storage-smartx-title, #0056b3);
  letter-spacing: -0.02em;
  line-height: 1.35;
  margin: 0;
}

.storage-dd-group-desc {
  margin: 8px 0 0;
  font-size: var(--storage-smartx-desc-size, 14px);
  line-height: 1.6;
  color: var(--storage-smartx-desc, #666666);
  font-weight: 400;
}

.storage-dd-item-main {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-item--storage {
  flex: 0 0 auto !important;
  width: 100% !important;
  min-height: auto !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  /* 避免 translateZ(0) 在部分显卡上导致文字发虚 */
  transform: none !important;
  backface-visibility: visible;
  will-change: auto;
}

/* 软件行：与左侧「软件」顶对齐，不再被 padding 顶下去 */
.tab-content--storage .product-item--storage-lead {
  padding-top: 0 !important;
}

/* 与分组主标题同档 20px */
.tab-content--storage .product-item--storage-lead h4 {
  font-size: var(--storage-smartx-title-size, 20px) !important;
  line-height: 1.35;
  font-weight: 600;
}

.tab-content--storage .product-item--storage-lead p {
  font-size: var(--storage-smartx-desc-size, 14px) !important;
  line-height: 1.6;
  color: var(--storage-smartx-desc, #666666) !important;
  -webkit-text-fill-color: #666666;
  opacity: 1 !important;
  margin: 8px 0 0;
}

.tab-content--storage .product-item--storage-model h4 {
  font-size: var(--storage-smartx-model-size, 15px) !important;
  line-height: 1.4;
  font-weight: 600;
}

.tab-content--storage .product-item--storage-model p {
  font-size: var(--storage-smartx-model-desc-size, 13px) !important;
  line-height: 1.55;
  color: var(--storage-smartx-desc, #666666) !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #666666;
}

/* 默认与选中：保持 SmartX 式饱和蓝，选中勿变浅灰 */
.tab-content--storage .product-item--storage h4 {
  color: var(--storage-smartx-title, #0056b3) !important;
  -webkit-text-fill-color: #0056b3;
  opacity: 1 !important;
  font-weight: 600;
}

.tab-content--storage .product-item--storage:hover h4 {
  color: #004494 !important;
  -webkit-text-fill-color: #004494;
}

.tab-content--storage .product-item--storage.product-item-selected h4 {
  color: var(--storage-smartx-title, #0056b3) !important;
  -webkit-text-fill-color: #0056b3;
}

.tab-content--storage .product-item--storage.product-item-selected p {
  color: var(--storage-smartx-desc, #666666) !important;
  -webkit-text-fill-color: #666666;
  opacity: 1 !important;
}

.mobile-storage-section {
  margin-bottom: 18px;
}

.mobile-storage-smartx-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
}

.mobile-storage-label-col {
  flex: 0 0 52px;
  min-width: 52px;
  font-size: 14px;
  font-weight: 400;
  color: #888888;
  line-height: 1.45;
  padding-top: 0;
  white-space: nowrap;
}

.mobile-storage-smartx-body {
  flex: 1;
  min-width: 0;
}

.mobile-storage-smartx-cta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.2rem 0.5rem;
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 12px;
  padding: 0.5rem 0.7rem;
  border-radius: 4px;
  text-decoration: none;
  color: #0f4a8a !important;
  background: #ffffff;
  border: 1px solid #17a56f;
  box-shadow: none;
}

.mobile-storage-smartx-cta__main {
  font-size: 13px;
  font-weight: 700;
  color: #0056b3;
}

.mobile-storage-smartx-cta__hint {
  flex: 1;
  min-width: 8rem;
  font-size: 10px;
  line-height: 1.35;
  color: #6b7280;
  opacity: 1;
}

.mobile-storage-smartx-cta__arrow {
  font-size: 0.92rem;
  font-weight: 500;
  color: #159a68;
}

.mobile-storage-smartx-cta--under-title {
  margin-bottom: 14px;
}

.mobile-storage-product-name {
  color: #0056b3 !important;
  font-weight: 600;
}

.mobile-product-item--nested {
  margin-left: 0;
  border-left: none;
  padding-left: 0;
}

.mobile-storage-group-banner {
  padding: 0;
  margin: 0 0 10px;
  background: transparent;
  border-radius: 0;
}

.mobile-storage-group-title {
  display: block;
  font-weight: 600;
  font-size: 20px;
  color: #0056b3;
  line-height: 1.35;
  letter-spacing: -0.02em;
}

.mobile-storage-group-desc {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  color: #666666;
  line-height: 1.55;
}

.tab-content {
  display: none;
  width: 100%;
  flex-direction: column; /* Ensure search box is above product items */
  align-items: flex-start; /* Align content to the left */
}

.product-items-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  justify-content: flex-start; /* Align items to the start */
  padding-top: 0; /* Remove top padding since section title is now separate */
  margin: 0;
  position: relative;
  z-index: 2;
}

.tab-content.active {
  display: flex;
}

.nav-links .router-link-active a {
  color: #007bff;
}

.nav-links li.active a {
  /* color: #007bff; */
  /* border-bottom: 2px solid #007bff; */
}
.search-box {
  position: relative;
  /* margin-right: 20px; */
  display: flex;
  align-items: center;
  width: 280px;
  height: 34px;
  padding: 0 12px 0 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  /* background: #f9fafb; */
  cursor: pointer;
  transition: all 0.2s ease;
  will-change: box-shadow;
  backface-visibility: hidden;
}
.search-box:hover {
  border-color: #d9d9d9;
  /* background: #f3f4f6; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.search-placeholder {
  flex: 1;
  font-size: 16px;
  color: #9ca3af;
  user-select: none;
  text-align: left;
}
.search-shortcut {
  padding: 2px 6px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #9ca3af;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background: url('../assets/search.svg') no-repeat center;
  background-size: contain;
  opacity: 0.5;
}
.login-btn, .register-btn {
  text-decoration: none;
  padding: 8px 20px;
  border-radius: 4px;
  margin-left: 10px;
}
.login-btn {
  color: var(--color-text);
}
.register-btn {
  background-color: var(--color-primary);
  color: #fff;
}

.user-menu {
  display: flex;
  align-items: center;
  gap: 10px;
}

.welcome-text {
  color: var(--color-text);
  font-size: 16px;
}

.logout-btn {
  padding: 6px 12px;
  background-color: #f56c6c;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.logout-btn:hover {
  background-color: #f78989;
}

.auth-buttons {
  display: flex;
  align-items: center;
}

/* Responsive */
@media (max-width: 1200px) {
  .nav-links li {
    margin: 0 15px;
  }
  .search-box input {
    width: 150px;
  }
}

@media (max-width: 1023px) {
  .nav-links {
    display: none;
  }
}
.nav-inner-container {
  width: 100%; /* Ensure it takes full width up to max-width */
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 24px; /* Add horizontal padding here */
}

.search-box-dropdown {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 0 0 26px 0;
  margin-bottom: 0;
  flex-shrink: 0;
}

.search-input-wrapper {
  position: relative;
  width: 100%;
}

.search-box-dropdown input {
  width: 100%;
  padding: 9px 35px 9px 35px; /* Adjust padding to prevent overlap */
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  box-sizing: border-box;
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  color: var(--color-text);
}
.search-box-dropdown input:focus {
  border-color: rgba(37, 99, 235, 0.45);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}
.search-box-dropdown input::placeholder {
  color: var(--color-text-muted);
  font-size: 15px;
}

.search-box-dropdown .search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  background: url('../assets/search.svg') no-repeat center;
  cursor: pointer;
  pointer-events: none; /* Prevent icon from blocking input */
}

/* 清除搜索按钮 */
.clear-search {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--color-text-muted);
  font-size: 18px;
  font-weight: bold;
  border-radius: 50%;
  transition: all 0.2s;
}

.clear-search:hover {
  background: #eef2ff;
  color: var(--color-primary);
}

/* 无结果提示 */
.no-results {
  width: 100%;
  padding: 40px 20px;
  text-align: center;
  color: var(--color-text-muted);
  font-size: 16px;
}

/* 搜索高亮 */
.product-item h4 :deep(mark),
.product-item p :deep(mark) {
  background: linear-gradient(120deg, #fef08a 0%, #fde047 100%);
  color: #854d0e;
  padding: 0 2px;
  border-radius: 2px;
}

/* 产品分类标签 */
.product-category-tag {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 2px 8px;
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  color: #0369a1;
  font-size: 13px;
  border-radius: 10px;
  font-weight: 500;
}

.product-item {
  position: relative;
}

/* 搜索结果计数 */
.result-count {
  font-size: 14px;
  font-weight: normal;
  color: var(--color-text-muted);
  margin-left: 8px;
}

/* 右侧产品参数（选中产品参数面板） */
.dropdown-params {
  width: 100%;
  min-width: 0;
  padding: 28px 32px;
  background: #f0f6ff;
  border-left: 1px solid #e2e8f0;
  box-sizing: border-box;
  position: relative;
}

.dropdown-params::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6 0%, #06b6d4 50%, #10b981 100%);
  border-radius: 0 0 4px 4px;
}

.dropdown-params .params-panel {
  background: transparent;
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
}

.dropdown-params .params-panel-header {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(59, 130, 246, 0.08);
}

.dropdown-params .params-panel-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
}

.dropdown-params .params-panel-desc {
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.5;
  margin: 0;
}

.dropdown-params .params-panel-body {
  margin-bottom: 0;
}

.dropdown-params .feature-cards-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.dropdown-params .feature-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(59, 130, 246, 0.08);
  transition: all 0.2s ease;
}

.dropdown-params .feature-card:hover {
  background: rgba(255, 255, 255, 0.95);
  border-color: rgba(59, 130, 246, 0.15);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.06);
}

.dropdown-params .feature-card-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(135deg, #eff6ff, #e0f2fe);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
}

.dropdown-params .feature-card-content {
  flex: 1;
  min-width: 0;
}

.dropdown-params .feature-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.dropdown-params .feature-card-desc {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

.dropdown-params .feature-card--title-only {
  align-items: center;
}

.dropdown-params .feature-card--title-only .feature-card-title {
  margin-bottom: 0;
  line-height: 1.45;
}

.params-panel-title {
  font-size: 17px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.3;
  min-width: 0;
  letter-spacing: -0.01em;
}

.params-panel-subtitle {
  width: 100%;
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
  margin-top: 12px;
  margin-bottom: 16px;
  padding: 12px 14px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  transition: none;
}

.product-inline-panel .params-more-link {
  -webkit-text-fill-color: #ffffff;
  color: #ffffff;
}

.product-inline-panel .params-more-link {
  color: #1f5fff;
  text-decoration: none;
  font-weight: 500;
}

.product-inline-panel .params-more-link:hover {
  color: #0f4cff;
  text-decoration: none;
}

.params-spec-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 12px 0;
  border-top: 1px solid #f1f5f9;
  width: 100%;
}

.params-spec-row:last-child {
  border-bottom: 1px solid #f1f5f9;
}

.params-spec-label {
  flex-shrink: 0;
  width: 140px;
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  line-height: 1.6;
  white-space: normal;
  text-align: left;
  word-break: break-word;
}

.params-spec-value {
  flex: 1;
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
  word-break: break-word;
  min-width: 0;
}

.params-spec-value.unknown {
  color: #e53935;
  font-weight: 700;
}

.solution-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: var(--shadow-lg);
  z-index: 1000;
  min-width: max-content; /* Ensure dropdown is at least as wide as its content */
  border-radius: var(--radius-sm);
  border: 1px solid var(--color-border);
}

.solution-dropdown .dropdown-inner-container {
  margin: 0;
  padding: 0;
  max-width: none;
}

.solution-items-container {
  display: flex;
  flex-direction: column;
  gap: 0; /* Changed from 10px to 0 */
  text-align: left;
}

.solution-items-container a{
  padding: 10px 14px;
}
/* 下拉菜单项样式重置 */
.solution-items-container a,
.service-items-container a {
  color: #353f4e !important;
  text-decoration: none !important;
}

.solution-item {
  display: flex;
  align-items: center;
  padding: 0;
  line-height: 1;
  height: fit-content;
  min-height: 0;
  font-size: 13px;
  margin: 0;
  text-decoration: none;
  color: #353f4e !important;
  transition: all 0.2s ease;
  border-radius: 6px;
  will-change: background-color;
  backface-visibility: hidden;
}

.solution-item:hover {
  background-color: var(--color-primary-soft);
  color: var(--color-primary) !important;
}

.solution-item.active {
  background-color: var(--color-primary-soft);
  color: var(--color-primary) !important;
}

.solution-new-dropdown {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  width: 100%;
  transform: none;
  background: #ffffff;
  border-top: 1px solid #eef2f6;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 24px 60px -16px rgba(0, 0, 0, 0.12), 0 12px 28px -8px rgba(0, 0, 0, 0.08);
  z-index: 1001;
}

/* 解决方案：三列 + 信创卡片同一行均匀排布 */
.solution-columns-layout {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) minmax(250px, 290px);
  align-items: start;
  column-gap: clamp(40px, 4.5vw, 72px);
  width: 100%;
  max-width: 1480px;
  margin: 0 auto;
  padding: 48px clamp(40px, 5vw, 72px) 56px;
  position: relative;
  background: transparent;
  box-sizing: border-box;
}

.solution-columns-main {
  display: contents;
}

.solution-column {
  min-width: 0;
  padding: 0;
  border-right: none;
  position: relative;
}

.solution-column:first-child,
.solution-column:last-child {
  padding-left: 0;
  padding-right: 0;
}

.solution-column-title {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  text-transform: none;
  letter-spacing: 0.04em;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
  position: relative;
}

.solution-column--1 .solution-column-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 48px;
  height: 3px;
  background: linear-gradient(90deg, #10b981 0%, #34d399 100%);
  border-radius: 2px;
}

.solution-column--2 .solution-column-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 48px;
  height: 3px;
  background: linear-gradient(90deg, #f59e0b 0%, #fbbf24 100%);
  border-radius: 2px;
}

.solution-column--3 .solution-column-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 48px;
  height: 3px;
  background: linear-gradient(90deg, #8b5cf6 0%, #a78bfa 100%);
  border-radius: 2px;
}

.solution-column-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.solution-column-item,
.solution-column-item.router-link-active {
  display: block !important;
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
  font-size: 16px !important;
  font-weight: 600;
  letter-spacing: -0.01em !important;
  line-height: 24px !important;
  color: #1e293b !important;
  text-decoration: none !important;
  padding: 10px 12px !important;
  margin: 0 !important;
  margin-bottom: 2px !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  border: 1px solid transparent !important;
  outline: none !important;
  background: transparent !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  white-space: normal;
}

.solution-column-item::after {
  display: none !important;
}

.solution-column-item:hover,
.solution-column-item:focus {
  color: #2563eb !important;
  background: linear-gradient(145deg, #f0f6ff 0%, #e5efff 100%) !important;
  border-color: #3b82f6 !important;
  text-decoration: none !important;
  box-shadow: 0 10px 30px rgba(59, 130, 246, 0.12) !important;
  transform: none;
}

.solution-featured {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  background: transparent;
  border-left: none;
}

.solution-featured-card {
  display: flex !important;
  flex-direction: column !important;
  width: 100%;
  height: 100%;
  min-height: 340px;
  padding: 0 !important;
  margin: 0 !important;
  text-decoration: none !important;
  color: inherit !important;
  background: #fff !important;
  border: 1px solid #e8edf5 !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.05) !important;
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease !important;
}

.solution-featured-card:hover,
.solution-featured-card:focus {
  transform: translateY(-2px);
  border-color: rgba(37, 99, 235, 0.18) !important;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08) !important;
  text-decoration: none !important;
}

.solution-featured-visual {
  position: relative;
  height: 168px;
  background: #dbeafe;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  width: 100%;
  border-radius: 12px 12px 0 0;
}

.solution-featured-banner-text {
  font-size: 28px;
  font-weight: 750;
  letter-spacing: 0.18em;
  line-height: 1.2;
  color: #1e3a8a;
  text-align: center;
}

.solution-featured-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 22px 22px 24px;
}

.solution-featured-topic {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #64748b;
}

.solution-featured-desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.7;
  color: #64748b;
  flex: 1;
}

.solution-featured-link {
  display: inline-flex;
  align-items: center;
  margin-top: 18px;
  font-size: 14px;
  font-weight: 600;
  color: #2563eb;
}

/* 恢复解决方案下拉右下角水印过渡遮罩 */
.solution-new-layout::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  width: 280px;
  height: 96px;
  background: radial-gradient(120% 120% at 100% 100%, #f5f9ff 0%, rgba(245, 249, 255, 0.94) 58%, rgba(245, 249, 255, 0) 100%);
  pointer-events: none;
  z-index: 0;
}

.solution-new-categories,
.solution-new-details {
  position: relative;
  z-index: 1;
}

.solution-new-categories {
  border-right: 1px solid #eef2f7;
  padding-right: 12px;
}

.solution-new-category {
  padding: 8px 12px;
  font-size: 13px;
  color: #475569;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 2px;
  font-weight: 500;
}

.solution-new-category:hover,
.solution-new-category.active {
  background: #eff6ff;
  color: #2563eb;
  border-left: 3px solid #2563eb;
  padding-left: 9px;
}

.solution-new-details {
  min-width: 0;
}

.solution-new-details-title {
  font-size: 18px;
  line-height: 1.3;
  color: #1e293b;
  font-weight: 600;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8ecf1;
  letter-spacing: -0.01em;
}

.solution-new-item {
  display: block;
  font-size: 13px;
  line-height: 1.5;
  color: #353f4e !important;
  text-decoration: none !important;
  padding: 14px 20px 14px 32px;
  margin-bottom: 6px;
  word-break: break-word;
  border-radius: 6px;
  border: 1px solid transparent;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
}

.solution-new-item:hover {
  color: #1d4ed8 !important;
  background-color: #f8fbff;
  border-color: #3b82f6;
  box-shadow: 0 3px 10px rgba(59, 130, 246, 0.1);
  text-decoration: none !important;
}

.service-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: max-content; /* Ensure dropdown is at least as wide as its content */
  border-radius: 4px;
}

.service-dropdown .dropdown-inner-container {
  margin: 0;
  padding: 0;
  max-width: none;
}

.service-items-container {
  display: flex;
  flex-direction: column;
  gap: 0; /* Changed from 10px to 0 */
  text-align: left;
}

.service-items-container a{
  padding: 15px 10px;
}

/* 下拉菜单项样式重置 */
.service-items-container a {
  color: var(--color-text-secondary) !important;
  text-decoration: none !important;
}


.solution-items-container a{
  border-bottom: 0px !important;
}
.service-items-container a{
  border-bottom: 0px !important;
}

.router-link-exact-active.active{
  color: var(--color-primary);
}
.service-item {
  display: flex; /* Change to flex to better control content alignment */
  align-items: center; /* Vertically center content */
  padding: 0; /* Remove all padding */
  line-height: 1; /* Explicitly set line-height to 1 */
  height: fit-content; /* Ensure height is determined by content */
  min-height: 0; /* Ensure no minimum height */
  font-size: 16px; /* Set a specific font size */
  margin: 0; /* Ensure no default margin */
  text-decoration: none;
  color: var(--color-text-secondary) !important;
  transition: all 0.2s ease;
  border-radius: 4px;
  will-change: background-color;
  backface-visibility: hidden;
}

.service-item:hover {
  background-color: var(--color-primary-soft);
  color: var(--color-primary) !important;
}

.service-item.active {
  background-color: var(--color-primary-soft);
  color: var(--color-primary) !important;
  font-weight: 500;
}

/* ===== 移动端样式 ===== */
/* 默认隐藏移动端组件 */
.mobile-menu-btn,
.mobile-overlay,
.mobile-menu {
  display: none;
}

@media (max-width: 1023px) {
  /* 隐藏PC端导航和登录注册 */
  .nav-links {
    display: none !important;
  }
  
  .auth-buttons {
    display: none !important;
  }
  
  .search-box {
    display: none !important;
  }
  
  /* 导航栏基础样式 */
  nav {
    height: 56px;
    padding-top: env(safe-area-inset-top);
    height: calc(56px + env(safe-area-inset-top));
  }
  
  .nav-inner-container {
    padding: 0 16px;
    position: relative;
  }
  
  /* 汉堡菜单按钮 - 放在右侧 */
  .mobile-menu-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
    z-index: 998;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    -webkit-tap-highlight-color: transparent;
  }
  
  .mobile-menu-btn span {
    display: block;
    height: 2px;
    width: 20px;
    background-color: var(--color-text);
    border-radius: 1px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: absolute;
  }
  
  .mobile-menu-btn span:nth-child(1) {
    transform: translateY(-6px);
  }
  
  .mobile-menu-btn span:nth-child(2) {
    transform: translateY(0);
  }
  
  .mobile-menu-btn span:nth-child(3) {
    transform: translateY(6px);
  }
  
  /* 汉堡菜单激活状态 - 隐藏（因为侧边栏有关闭按钮） */
  .mobile-menu-btn.is-active {
    opacity: 0;
    pointer-events: none;
  }
  
  /* 遮罩层 */
  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    z-index: 1000;
    -webkit-tap-highlight-color: transparent;
  }
  
  .mobile-overlay.is-visible {
    opacity: 1;
    visibility: visible;
  }
  
  /* 移动端侧边菜单 */
  .mobile-menu {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: 0;
    width: min(320px, 88vw);
    max-width: 100%;
    height: 100vh;
    height: 100dvh;
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    transform: translateX(100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1001;
    overflow: hidden;
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }
  
  .mobile-menu.is-open {
    transform: translateX(0);
  }
  
  /* 移动端菜单头部 */
  .mobile-menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid var(--color-border);
    flex-shrink: 0;
  }
  
  .mobile-logo img {
    height: 24px;
  }
  
  .mobile-close-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--color-text-muted);
    border-radius: 50%;
    transition: all 0.2s;
    -webkit-tap-highlight-color: transparent;
  }
  
  .mobile-close-btn:active {
    background-color: var(--color-primary-soft);
  }
  
  /* 移动端菜单内容 */
  .mobile-menu-content {
    flex: 1;
    overflow-y: auto;
    padding: 8px 0;
    -webkit-overflow-scrolling: touch;
  }
  
  /* 导航项 */
  .mobile-nav-item {
    border-bottom: 1px solid var(--color-border);
  }
  .mobile-nav-item--hidden {
    display: none !important;
  }
  
  .mobile-nav-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 16px 20px;
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: var(--color-text);
    text-decoration: none;
    cursor: pointer;
    transition: background-color 0.2s;
    -webkit-tap-highlight-color: transparent;
    text-align: left;
  }
  
  .mobile-nav-link span {
    flex: 1;
    text-align: left;
  }
  
  .mobile-nav-link:active {
    background-color: var(--color-primary-soft);
  }
  
  /* 手风琴箭头 */
  .accordion-arrow {
    transition: transform 0.3s ease;
    flex-shrink: 0;
    color: var(--color-text-muted);
    margin-left: auto;
  }
  
  .accordion.is-expanded .accordion-arrow {
    transform: rotate(180deg);
  }
  
  /* 手风琴内容 */
  .accordion-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background-color: #f8fbff;
  }
  
  .accordion.is-expanded .accordion-content {
    max-height: min(70dvh, 2000px);
    overflow-y: auto;
  }
  
  /* 手风琴链接 */
  .accordion-link {
    display: block;
    padding: 14px 20px 14px 36px;
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: var(--color-text-secondary);
    text-decoration: none;
    text-align: left;
    transition: all 0.2s;
    border-bottom: 1px solid var(--color-border);
    -webkit-tap-highlight-color: transparent;
    white-space: normal;
    overflow: visible;
    word-break: break-word;
    line-height: 1.45;
  }
  
  .accordion-link:last-child {
    border-bottom: none;
  }
  
  .accordion-link:active {
    background-color: var(--color-primary-soft);
    color: var(--color-primary);
  }
  
  /* 移动端产品分类tabs：两行铺满，无需左右滑动 */
  .mobile-product-tabs {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    padding: 12px 16px;
    gap: 8px;
    border-bottom: 1px solid var(--color-border);
    background-color: #fff;
    overflow: visible;
  }

  .mobile-solution-tabs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  
  .mobile-product-tabs::-webkit-scrollbar {
    display: none;
  }
  
  .mobile-tab {
    min-width: 0;
    padding: 6px 4px;
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: var(--color-text-secondary);
    background-color: #eef2f7;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.2s;
    -webkit-tap-highlight-color: transparent;
    text-align: center;
    white-space: nowrap;
    overflow: visible;
  }
  
  .mobile-tab.active {
    color: #fff;
    background: linear-gradient(90deg, var(--color-primary) 0%, #60a5fa 100%);
  }
  
  .mobile-tab:active {
    transform: scale(0.95);
  }
  
  /* 移动端产品列表 */
  .mobile-product-list {
    padding: 8px 0;
  }
  
  .mobile-product-item {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 12px 20px;
    text-decoration: none;
    transition: background-color 0.2s;
    -webkit-tap-highlight-color: transparent;
  }
  
  .mobile-product-item:active {
    background-color: var(--color-primary-soft);
  }
  
  .mobile-product-item img {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    margin-right: 12px;
  }
  
  .mobile-product-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    text-align: left;
  }
  
  .mobile-product-name {
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: var(--color-text);
    white-space: normal;
    overflow: visible;
    word-break: break-word;
    text-align: left;
    width: 100%;
  }
  
  .mobile-product-desc {
    font-family: PingFang SC, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #999;
    white-space: normal;
    overflow: visible;
    word-break: break-word;
    line-height: 1.45;
    text-align: left;
    width: 100%;
  }
}

/* 超小屏幕优化 */
@media (max-width: 375px) {
  .mobile-menu {
    width: 90%;
  }
  
  .mobile-nav-link {
    padding: 14px 16px;
    font-size: 17px;
  }
  
  .accordion-link {
    padding: 12px 16px 12px 28px;
    font-size: 15px;
  }
  
  .mobile-product-item {
    padding: 10px 16px;
  }
  
  .mobile-product-item img {
    width: 32px;
    height: 32px;
  }
  
  .mobile-product-tabs {
    padding: 12px 16px;
  }
}
</style>